// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FondoHeaderTabla2 {
  background-color: #006699;
  font-size: 16px;
}

.FondoHeaderTabla3 {
  background-color: #006699;
  font-size: 12px !important;
}

.object-box {
  position: absolute;
  border: 2px solid blue;
  z-index: 9999;
}

.object-box2 {
  position: absolute;
  border: 2px solid red;
  z-index: 9999;
}

.image-container {
  position: relative;
}

.countersColorsTrafico {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-self: flex-start;
  justify-content: center;
  flex-wrap: wrap;
}

.countersColorsTrafico>div {
  margin-right: 12px;

}

.countersColorsTrafico>.red {
  background-color: #E02B28;
}

.countersColorsTrafico>.yellow {
  background-color: #E0A019;
}

.countersColorsTrafico>.green {
  background-color: #5DE02B;
}

.countersColorsTrafico>.blue {
  background-color: #006699;
}

.countersColorsTrafico>.trans {
  background-color: transparent;
}

.trafico-alerts-toolbar {
  transform: translateX(-28px);
}

.trafico-company-filter {
  width: 300px;
  min-width: 260px;
  position: relative;
  z-index: 120;
  align-self: center;
  margin-bottom: 0;
}

.trafico-company-select__control {
  height: 38.94px;
  min-height: 38.94px;
  border-color: #cbd5df !important;
  box-shadow: none !important;
  font-size: 14px;
}

.trafico-company-select__value-container {
  height: 38.94px;
  padding: 0 10px;
  align-items: center;
}

.trafico-company-select__indicators {
  height: 38.94px;
}

.trafico-company-select__control:hover,
.trafico-company-select__control--is-focused {
  border-color: #6c9fbd !important;
}

.trafico-company-select__menu {
  z-index: 2000 !important;
}

.trafico-company-select__option--is-focused {
  background: #e7f3fa;
  color: #17324a;
}

.trafico-company-select__option--is-selected {
  background: #0874a8;
}

/* Encabezado fijo al hacer scroll */
#tablaTRAF thead th {
  position: sticky;
  top: 0;
  z-index: auto;
  /* por encima de las filas */
  background-color: #006699;
  /* reproduce tu FondoHeaderTabla2 */
  color: #fff;
}

/* Quita el z-index elevado de las celdas del body para no tapar el thead */
.cardContainerTrafico #tablaTRAF tbody td {
  z-index: auto;
}

/* Grilla de Tráfico: las filas se desplazan verticalmente dentro de la tabla. */
.trafico-table-freeze-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #8ea9bd transparent;
  -webkit-overflow-scrolling: touch;
}

/*
 * En portátiles/tablets grandes se conserva la tabla de escritorio, pero sus
 * columnas no caben siempre en el viewport. En ese rango el wrapper debe ser
 * la única superficie de scroll horizontal. El escritorio amplio conserva el
 * comportamiento actual y las tarjetas responsive (<= 1199px) no se tocan.
 */
@media (min-width: 1200px) and (max-width: 1599px) {
  .trafico-table-freeze-wrapper {
    overflow-x: auto !important;
  }

  .cardContainerTrafico .table-responsive .trafico-table-freeze-2 {
    width: max-content !important;
    min-width: 100% !important;
    max-width: none !important;
  }
}

.trafico-table-freeze-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.trafico-table-freeze-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.trafico-table-freeze-wrapper::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 999px;
  background: #8ea9bd;
  background-clip: padding-box;
}

.trafico-table-freeze-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #5d819a;
}

.cardContainerTrafico .table-responsive .trafico-table-freeze-2 {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
}

.trafico-table-freeze-2 th:nth-child(1),
.trafico-table-freeze-2 td:nth-child(1) {
  width: 220px;
  min-width: 220px;
}

.trafico-table-freeze-2 th:nth-child(2),
.trafico-table-freeze-2 td:nth-child(2) {
  width: 210px;
  min-width: 210px;
}

.trafico-table-freeze-2 tbody tr {
  background-color: #fff;
}

.trafico-table-freeze-2 thead th:nth-child(-n + 2),
.trafico-table-freeze-2 tbody td:nth-child(-n + 2):not([colspan]) {
  position: sticky;
  z-index: 20;
  background-color: inherit;
  background-clip: padding-box;
}

.trafico-table-freeze-2 thead th:nth-child(-n + 2) {
  z-index: 30 !important;
  background-color: #006699;
}

.trafico-table-freeze-2 th:nth-child(1),
.trafico-table-freeze-2 td:nth-child(1):not([colspan]) {
  left: 0;
}

.trafico-table-freeze-2 th:nth-child(2),
.trafico-table-freeze-2 td:nth-child(2):not([colspan]) {
  left: 220px;
  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);
}

.trafico-table-freeze-2 thead th,
.trafico-table-freeze-2 tbody td {
  overflow-wrap: normal;
  word-break: normal;
}

.trafico-table-freeze-2 thead th {
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}

.trafico-table-freeze-2 tbody td {
  min-width: 42px;
}

.trafico-table-freeze-2 tbody td.trafico-ubic-gps-cell {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 214px;
  max-width: 214px;
  vertical-align: top;
}

.trafico-table-freeze-2 tbody td.trafico-observaciones-cell {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  vertical-align: top;
}

.trafico-table-freeze-2 tbody td:nth-child(2) {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  overflow: visible !important;
  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);
}

.trafico-device-link {
  appearance: none;
  position: relative;
  display: inline-block;
  padding: 0;
  border: 0;
  background: transparent;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  color: #006699;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.device-live-wrap:has(.custom-tooltip:hover),
.device-live-wrap:has(.custom-tooltip:focus-within) {
  position: relative;
  z-index: 10000;
}

/* El tooltip vive dentro de la segunda columna fija. Elevar la fila y la
   celda activa evita que las columnas siguientes o el encabezado sticky lo
   cubran durante el hover/focus. */
.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:hover),
.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:focus-within) {
  position: relative;
  z-index: 1000;
}

.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:hover) td:nth-child(2),
.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:focus-within) td:nth-child(2) {
  position: sticky;
  z-index: 1100 !important;
  overflow: visible !important;
}

.custom-tooltip,
.custom-tooltip::after {
  z-index: 100000 !important;
}

.trafico-device-link[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  z-index: 1000;
  width: max-content;
  max-width: 260px;
  padding: 7px 9px;
  border-radius: 6px;
  background: #1f3448;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  text-align: left;
  white-space: normal;
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 4px);
  transition: opacity 140ms ease, transform 140ms ease;
}

.trafico-device-link[data-tooltip]:hover::after,
.trafico-device-link[data-tooltip]:focus-visible::after {
  opacity: 1;
  transform: translate(-50%, 0);
}

.trafico-device-link:hover,
.trafico-device-link:focus-visible {
  color: #004b73;
}

.trafico-device-link:focus-visible {
  outline: 2px solid #006699;
  outline-offset: 3px;
  border-radius: 2px;
}

.trafico-table-freeze-2 tbody .trafico-placa-cell {
  text-align: center;
  vertical-align: middle;
}

.trafico-camera-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
}

.trafico-camera-button:hover {
  background-color: rgba(0, 102, 153, 0.1);
}

.trafico-camera-button:focus-visible {
  outline: 2px solid #006699;
  outline-offset: 2px;
}

@media (min-width: 1400px) {
  .trafico-table-freeze-wrapper {
    overflow-x: hidden !important;
  }

  .cardContainerTrafico .table-responsive .trafico-table-freeze-2 {
    width: 100%;
    min-width: 0;
    table-layout: fixed;
  }

  .trafico-table-freeze-2 th:nth-child(1),
  .trafico-table-freeze-2 td:nth-child(1) {
    width: 150px !important;
    min-width: 150px !important;
  }

  .trafico-table-freeze-2 th:nth-child(2),
  .trafico-table-freeze-2 td:nth-child(2) {
    width: 145px !important;
    min-width: 145px !important;
  }

  .trafico-table-freeze-2 th:nth-child(2),
  .trafico-table-freeze-2 td:nth-child(2):not([colspan]) {
    left: 150px;
  }

  .trafico-table-freeze-2 thead th:nth-child(3) {
    width: 42px !important;
  }

  .trafico-table-freeze-2 thead th:nth-child(4) {
    width: 86px !important;
  }

  .trafico-table-freeze-2 thead th:nth-child(5) {
    width: 115px !important;
  }

  .trafico-table-freeze-2 thead th:nth-child(6) {
    width: 155px !important;
  }

  .trafico-table-freeze-2 thead th:nth-child(7) {
    width: 110px !important;
  }

  .trafico-table-freeze-2 thead th:nth-child(8) {
    width: 190px !important;
  }

  .trafico-table-freeze-2 thead th:nth-child(9),
  .trafico-table-freeze-2 tbody td:nth-child(9) {
    width: 145px !important;
    min-width: 145px !important;
    max-width: 145px !important;
    white-space: normal;
  }

  .trafico-table-freeze-2 thead th:nth-child(n + 10):not(.trafico-tiempo-col) {
    width: 38px !important;
    min-width: 38px !important;
    padding-left: 6px;
    padding-right: 6px;
  }

  .trafico-table-freeze-2 thead th,
  .trafico-table-freeze-2 tbody td {
    padding-left: 8px;
    padding-right: 8px;
  }

  .trafico-table-freeze-2 tbody td {
    min-width: 0;
  }

  .trafico-table-freeze-2 th.trafico-ruta-col,
  .trafico-table-freeze-2 td.trafico-ruta-col {
    width: 155px !important;
    max-width: 155px;
  }

  .trafico-table-freeze-2 thead th.trafico-tiempo-col,
  .trafico-table-freeze-2 tbody td.trafico-tiempo-col {
    width: 75px !important;
    min-width: 75px !important;
    max-width: 75px !important;
    white-space: nowrap;
  }

  .trafico-table-freeze-2 tbody td.trafico-ubic-gps-cell {
    min-width: 190px;
    max-width: 190px;
  }
}

.my-custom-collapse {
  display: none;
  /* Oculta las filas colapsables de forma predeterminada */
}

.my-custom-show {
  display: table-row;
  /* Muestra las filas colapsables cuando tienen la clase "show" */
}

/* Estilos adicionales según tus necesidades */
.my-custom-collapse td {
  /* Estilos para las celdas de las filas colapsables */
}

.counterItem {
  position: relative;
  border: 1px solid #ddd;
  /* Un color de borde más suave */
  border-radius: 8px;
  padding: 5px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1),
    0px 8px 15px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.counterItem.active {
  background-color: #dfdddd;
  box-shadow: 0px 4px 6px #006699,
    0px 8px 15px rgba(0, 0, 0, 0.1);
}

.counterItem.inactive {
  background-color: #fff;

}

/* ======== USUARIOS COMPONENT ======== */
.usuarios .table-responsive {
  overflow-x: auto;
  /* scroll horizontal */
  overflow-y: auto;
  /* si también quieres vertical dentro del card */
  -webkit-overflow-scrolling: touch;
  max-height: 70vh;
  /* opcional: limita alto del contenedor */
}

/* Evita que el contenido haga wrap y fuerce el ancho total de la tabla */
.usuarios .table-responsive.text-nowrap,
.usuarios .table-responsive .table,
.usuarios .table-responsive .table th,
.usuarios .table-responsive .table td {
  white-space: wrap;
}

/* Contenedor con scroll y altura controlada */
.rolesTable {
  overflow-x: auto;
  /* scroll horizontal cuando haga falta */
  overflow-y: auto;
  /* scroll vertical dentro de la card si crece */
  -webkit-overflow-scrolling: touch;
  /* inercia en iOS */
  max-height: 60vh;
  /* ajusta a tu gusto o quítalo */
  border-radius: 8px;
}

/* Tabla estable con columnas predecibles */
.rolesTable .table {
  table-layout: fixed;
  /* fija el layout y respeta anchos */
  width: 100%;
}

/* Alineación y legibilidad */
.rolesTable .table th,
.rolesTable .table td {
  vertical-align: middle;
}

/* Header pegado y legible (usa tu color de .FondoHeaderTabla2 si ya lo define) */
.rolesTable .FondoHeaderTabla2 th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #006699;
  /* asegura contraste si tu clase no lo pone */
  color: #ffffff;
  white-space: nowrap;
  /* encabezados en 1 línea */
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
}

/* Columnas: ID chica, NOMBRE ocupa, OPCIONES compacta */
.rolesTable .table thead th:nth-child(1),
.rolesTable .table tbody td:nth-child(1) {
  width: 110px;
}

.rolesTable .table thead th:nth-child(2),
.rolesTable .table tbody td:nth-child(2) {
  width: 100%;
}

/* NOMBRE crece */

.rolesTable .table thead th:nth-child(3),
.rolesTable .table tbody td:nth-child(3) {
  width: 120px;
}

/* Por defecto traes 'text-nowrap' en el contenedor: anulamos para el contenido */
.rolesTable.text-nowrap,
.rolesTable .table,
.rolesTable .table th,
.rolesTable .table td {
  white-space: normal !important;
  /* permite múltiples líneas en celdas */
  word-break: break-word;
  /* rompe textos larguísimos */
}

/* Dropdowns no se cortan dentro del contenedor scrolleable */
.rolesTable .dropdown.position-static {
  position: static;
}

/* (Opcional) Header pegado mientras haces scroll vertical en el contenedor */
.usuarios .FondoHeaderTabla2 th {
  position: sticky;
  top: 0;
  z-index: 2;
  /* Asegura contraste si tu .FondoHeaderTabla2 no define bg/text */
  background-color: #006699;
  /* pon tu color de header si aplica */
  color: #ffffff;
}

/* (Opcional) Sombrita cuando el header está pegado */
/* .usuarios .FondoHeaderTabla2 th {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
}

/* Evita que el dropdown se recorte dentro del contenedor con overflow */
/* .usuarios .dropdown.position-static {
  position: static;
} */
.btn.active {
  box-shadow: 0px 4px 6px #006699, 0px 8px 15px rgba(0, 0, 0, 0.1);
  background-color: #dfdddd;
  color: #006699;
}

.notification {
  display: flex;
  align-items: center;
  /* Alinear verticalmente */
}

/* Estilos para el badge circular palpitante */
/* Estilos para el badge circular palpitante */
.notification-badge {
  position: absolute;
  top: -5px;
  /* Ajusta la posición del badge */
  right: -5px;
  /* Ajusta la posición del badge */
  width: 15px;
  /* Tamaño del badge */
  height: 15px;
  /* Tamaño del badge */
  background-color: #006699;
  /* Color del badge */
  border-radius: 50%;
  /* Hace que sea un círculo */
  animation: pulse 1.5s infinite;
  /* Hace que palpite */
  border: 2px solid white;
  /* Opcional: agrega un borde blanco */
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }

  50% {
    transform: scale(1.4);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}



.notificationCount {
  position: absolute;
  /* Posicionar el contador */
  top: -25px;
  /* Ajusta según sea necesario */
  right: 10px;
  /* Ajusta según sea necesario */
  /* background-color: red; */
  /* Fondo rojo */
  color: #697A8D;
  /* Color del texto */
  border-radius: 50%;
  /* Hacerlo circular */
  width: 20px;
  /* Ancho del círculo */
  height: 20px;
  /* Alto del círculo */
  display: flex;
  justify-content: center;
  /* Centra el texto */
  align-items: center;
  font-weight: 700;
  /* Centra el texto */
  font-size: 17px;
  /* Tamaño de la fuente */
}


.cardContainerTrafico .table-responsive thead th {
  position: sticky;
  top: 0;
  /* z-index: 10; */
  background-color: #006699;
  /* o usa el mismo color que .FondoHeaderTabla2 */
  color: white;
}



/* ==========================
   TABLE FREEZE 4 (FIXED LEFT)
   - 4 primeras columnas fijas
   - THEAD sticky arriba
   - Col 5+ del THEAD SIEMPRE por debajo de las 4 fijas
   ========================== */

/* Wrapper con scroll */
.table-responsive-freeze {
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* si usas altura fija en inline style, perfecto */
}

/* Tabla */
.table-freeze-4 {
  min-width: 2000px;
  border-collapse: separate; /* necesario para sticky + sombras */
  border-spacing: 0;
}

/* ==========================
   THEAD sticky general (col 5+)
   ========================== */
.table-freeze-4 thead th {
  position: sticky;
  top: 0;
  z-index: 2 !important;         /* col 5+ queda por debajo */
  background: #0b2f4a;
  color: #fff;
  /* opcional: evita transparencias raras */
  background-clip: padding-box;
  /* opcional: mejora lectura */
  white-space: nowrap;
}

/* ==========================
   TBODY normal (col 5+)
   ========================== */
.table-freeze-4 tbody td {
  width: 100px;
  overflow: visible;
  white-space: normal;
  background: #fff;              /* importante para tapar lo de atrás */
  background-clip: padding-box;
}

/* ==========================
   4 columnas fijas (TBODY)
   ========================== */
.table-freeze-4 tbody td:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 10;
  background: #fff;
}
.table-freeze-4 tbody td:nth-child(2) {
  position: sticky;
  left: 220px;
  z-index: 10;
  background: #fff;
}
.table-freeze-4 tbody td:nth-child(3) {
  position: sticky;
  left: 320px;
  z-index: 10;
  background: #fff;
}
.table-freeze-4 tbody td:nth-child(4) {
  position: sticky;
  left: 420px;
  z-index: 10;
  background: #fff;
}

/* ==========================
   4 columnas fijas (THEAD)
   - estas SIEMPRE por encima de col 5+
   ========================== */
.table-freeze-4 thead th:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 50 !important;
  background: #0b2f4a;
}
.table-freeze-4 thead th:nth-child(2) {
  position: sticky;
  left: 220px;
  z-index: 50 !important;
  background: #0b2f4a;
}
.table-freeze-4 thead th:nth-child(3) {
  position: sticky;
  left: 320px;
  z-index: 50 !important;
  background: #0b2f4a;
}
.table-freeze-4 thead th:nth-child(4) {
  position: sticky;
  left: 420px;
  z-index: 50 !important;
  background: #0b2f4a;
}

/* Separador visual después de la col 4 */
.table-freeze-4 thead th:nth-child(4),
.table-freeze-4 tbody td:nth-child(4) {
  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);
}


/* Anchos fijos (ajusta a tus columnas reales) */
.table-freeze-4 th:nth-child(1),
.table-freeze-4 td:nth-child(1) { width: 220px; min-width: 220px; }

.table-freeze-4 th:nth-child(2),
.table-freeze-4 td:nth-child(2) { width: 135px; min-width: 135px; }

.table-freeze-4 th:nth-child(3),
.table-freeze-4 td:nth-child(3) { width: 100px; min-width: 100px; }

.table-freeze-4 th:nth-child(4),
.table-freeze-4 td:nth-child(4) { width: 150px; min-width: 150px; }

/* Ajustes de la tabla de Histórico: los offsets deben coincidir con los
   anchos reales y text-nowrap no debe impedir envolver el contenido. */
.cardControlHistorico .table-freeze-4 thead th:nth-child(2),
.cardControlHistorico .table-freeze-4 tbody td:nth-child(2) {
  left: 220px;
}

.cardControlHistorico .table-freeze-4 thead th:nth-child(3),
.cardControlHistorico .table-freeze-4 tbody td:nth-child(3) {
  left: 355px;
}

.cardControlHistorico .table-freeze-4 thead th:nth-child(4),
.cardControlHistorico .table-freeze-4 tbody td:nth-child(4) {
  left: 455px;
}

.cardControlHistorico .table-freeze-4 tbody td {
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* ==========================
   IMPORTANTE:
   Si tienes reglas globales tipo:
   tbody td { z-index: 999; }
   te va a romper esto. Elimínalas o escópalas.
   ========================== */

/* ================================
   SOLO TABLA DEVICES (id=tablaDevices)
   - Ul.Contrato (col 2) no se encoge al hacer scroll
   ================================ */

/* =========================
   Freeze 4 SOLO en #tablaDevices
   ========================= */

/* Header sticky */
#tablaDevices thead th{
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #006699 !important;
}

/* Columnas fijas (thead y tbody) */
#tablaDevices.table-freeze-4 thead th:nth-child(1),
#tablaDevices.table-freeze-4 tbody td:nth-child(1),
#tablaDevices.table-freeze-4 thead th:nth-child(2),
#tablaDevices.table-freeze-4 tbody td:nth-child(2),
#tablaDevices.table-freeze-4 thead th:nth-child(3),
#tablaDevices.table-freeze-4 tbody td:nth-child(3),
#tablaDevices.table-freeze-4 thead th:nth-child(4),
#tablaDevices.table-freeze-4 tbody td:nth-child(4) {
  position: sticky;            /* <-- esto faltaba */
  z-index: 10;
  background: #fff;
  background-clip: padding-box;
}

/* Encabezados de las fijas encima del resto */
#tablaDevices.table-freeze-4 thead th:nth-child(1),
#tablaDevices.table-freeze-4 thead th:nth-child(2),
#tablaDevices.table-freeze-4 thead th:nth-child(3),
#tablaDevices.table-freeze-4 thead th:nth-child(4) {
  z-index: 50;
  background-color: #006699 !important;
  color: #fff;
}

/* Offsets (según tus anchos) */
#tablaDevices.table-freeze-4 thead th:nth-child(1),
#tablaDevices.table-freeze-4 tbody td:nth-child(1) { left: 0; }

#tablaDevices.table-freeze-4 thead th:nth-child(2),
#tablaDevices.table-freeze-4 tbody td:nth-child(2) { left: 220px; }

#tablaDevices.table-freeze-4 thead th:nth-child(3),
#tablaDevices.table-freeze-4 tbody td:nth-child(3) { left: 360px; }

#tablaDevices.table-freeze-4 thead th:nth-child(4),
#tablaDevices.table-freeze-4 tbody td:nth-child(4) { left: 460px; }

/* Separador visual después de la col 4 */
#tablaDevices.table-freeze-4 thead th:nth-child(4),
#tablaDevices.table-freeze-4 tbody td:nth-child(4) {
  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);
}

/* Ul.Contrato fijo de ancho */
#tablaDevices thead th:nth-child(2),
#tablaDevices tbody td:nth-child(2) {
  width: 140px !important;
  min-width: 140px !important;
  max-width: 140px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Estabilidad general */
#tablaDevices { table-layout: fixed; }


.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1;
  /* Asegura que los encabezados se muestren por encima del contenido */
  font-weight: bold;
  /* Otras propiedades de estilo según tu preferencia */
  background-color: #006699;
  color: #ffffff;
  font-size: 12px;
}

.sticky-header2 {
  position: sticky;
  top: 0;
  z-index: 1;
  /* Asegura que los encabezados se muestren por encima del contenido */
  font-weight: bold;
  /* Otras propiedades de estilo según tu preferencia */
  background-color: #006699;
  color: #ffffff;
  font-size: 14px;
}

.background-class {
  background-color: #FFCCCC;
  /* Cambia este color al que prefieras */
}

.background-class2 {
  background-color: black;
  color: white;
  /* Cambia este color al que prefieras */
}

.background-class3 {
  background-color: #e0d96b;
  color: black;
  /* Cambia este color al que prefieras */
}

/* Hover con contraste propio para cada estado de la lista de mensajes. */
.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr > td {
  background-color: #ffffff;
  color: #212529;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class > td {
  background-color: #ffcccc;
  color: #4a0b0b;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class2 > td {
  background-color: #000000;
  color: #ffffff;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class3 > td {
  background-color: #e0d96b;
  color: #211f00;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr:not(.background-class):not(.background-class2):not(.background-class3):hover,
.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr:not(.background-class):not(.background-class2):not(.background-class3):hover > td {
  background-color: #d6e9f8 !important;
  color: #102a43 !important;
  box-shadow: none !important;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class:hover,
.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class:hover > td {
  background-color: #e99a9a !important;
  color: #4a0b0b !important;
  box-shadow: none !important;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class2:hover,
.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class2:hover > td {
  background-color: #28323c !important;
  color: #ffffff !important;
  box-shadow: none !important;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class3:hover,
.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class3:hover > td {
  background-color: #c8bf3f !important;
  color: #211f00 !important;
  box-shadow: none !important;
}

.oculto {
  visibility: collapse;
  display: none;
}

.botonLetra {
  font-size: 8px;
}

.custom-label {
  font-size: 8px;
}

.custom-navbar {
  background-color: #006699;
  /* Reemplaza esto con tu color personalizado */
  color: #fff;
}

.custom-switch .form-check-input:checked {
  background-color: #2EA4B1;
  /* Cambia este valor al color deseado */
}

.cardContainerTrafico .table-responsive table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

/* table {
  table-layout: fixed;
  width: 100%;
} */

.cardContainerTrafico tbody td {
  width: 100px;
  white-space: nowrap;
  overflow: inherit !important;
  white-space: initial;
  z-index: 999;
}

.textSmall {
  font-size: 12px;
}

.textSmall2 {
  font-size: 10px;
}

.textCenterIcon {
  width: 100%;
  text-align: center;
}

#success-alert {
  position: fixed;
  top: 0;
  right: 0;
  width: 30%;
  z-index: 999;
}

#danger-alert {
  position: fixed;
  top: 0;
  right: 0;
  width: 30%;
  z-index: 999;
}

#dialog {
  z-index: 1000;
}

.ui-dialog-titlebar {
  background: #2EA4B1;
  color: #ffffff;
}



#ModalGaleria .modal-content {
  background-color: #ffffff;
  z-index: 1000;
}

#ModalGaleria .sweet-alert-popup {
  z-index: 1051;
  /* Ajusta el z-index según sea necesario para que esté por encima del modal */
}


.dropdown {
  position: relative;
  z-index: 1000;
}

.containerSpaceMenu {
  padding-left: 0;
}

.dropdown-item {
  width: 100% !important;
  display: block;
  box-sizing: border-box;
}

.dropdown-item.dropdown-toggle-row {
  width: 100% !important;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  text-align: left;
  border: 0;
  background: transparent;
}

.dropdown-item.dropdown-toggle-row > span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dropdown-item-chevron {
  margin-left: auto;
  flex: 0 0 auto;
}

.en-vivo-menu-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.en-vivo-live-dot {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.en-vivo-live-dot::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e11d48;
  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);
  animation: en-vivo-pulse 1.2s ease-out infinite;
}

.live-counter-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #e11d48;
  color: #e11d48;
  font-size: 0.7rem;
  font-weight: 700;
  background: #fff;
}

.live-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #e11d48;
  background: #fff;
  color: #e11d48;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
}

.live-pill-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e11d48;
  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);
  animation: en-vivo-pulse 1.2s ease-out infinite;
}

.device-live-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.empresa-live-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.live-inline-section .live-inline-body {
  padding: 12px 14px;
}

.live-inline-section .live-inline-grid {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
}

.trafico-live-stack {
  display: flex;
  flex-direction: column;
  gap: 0;
  height: calc(100vh - 180px);
}

.trafico-contracts-grid {
  min-height: 220px;
}

.trafico-resize-handle {
  height: 8px;
  cursor: row-resize;
  background: linear-gradient(180deg, #dbe6ef 0%, #c9d7e2 100%);
  border-top: 1px solid #b9c9d6;
  border-bottom: 1px solid #b9c9d6;
}

.trafico-resize-handle:hover {
  background: linear-gradient(180deg, #cfddea 0%, #bacbd8 100%);
}

.trafico-live-section {
  flex: 1 1 auto;
  min-height: 160px;
  display: flex;
  width: 100%;
}

.trafico-live-section .live-inline-section {
  margin-top: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.trafico-live-section .live-inline-body {
  flex: 1 1 auto;
  overflow: auto;
}

.trafico-live-modal .live-inline-section {
  margin-top: 0 !important;
  width: 100%;
}

.trafico-live-modal .live-inline-body {
  height: 100%;
}

.trafico-live-modal {
  z-index: 11000 !important;
}

/* El panel de configuraciÃ³n debe quedar por encima del botÃ³n flotante Live. */
.trafico-control-offcanvas {
  z-index: 2100 !important;
}

@media (max-width: 768px) {
  .trafico-live-modal {
    left: 0 !important;
    right: 0 !important;
    top: 56px !important;
    bottom: 0 !important;
    width: auto !important;
    height: auto !important;
  }
}

@keyframes en-vivo-pulse {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(225, 29, 72, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0);
  }
}

/*  */

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.badge-danger {
  color: #fff;
  background-color: #dc3545;
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}

.ml-1 {
  margin-left: 0.25rem;
}


.traficoTR>td {
  padding: 5px;

}

span {
  cursor: pointer;
}

.scroll-offset {
  scroll-margin-top: 40px;
  /* Ajusta este valor según la altura de tu header */
}


/* Puedes ajustar los colores y la duración del parpadeo a tu gusto */
@keyframes blink-bg {
  0% {
    background-color: #ffeb3b;
    /* amarillo claro */
  }

  50% {
    background-color: #fff9c4;
    /* amarillo pastel */
  }

  100% {
    background-color: #ffeb3b;
    /* amarillo claro */
  }
}

.blink-bg {
  animation: blink-bg 1s ease-in-out 3;
  /* 1s de animación, 3 repeticiones */
}




@media (max-width: 1400px) {
  #tablaDevices.table-freeze-4 thead th,
  #tablaDevices.table-freeze-4 tbody td {
    position: static !important;
    left: auto !important;
  }
  .containerReporteContratoSeguimiento {
    width: 100%;
    overflow-x: scroll;
  }

  #FilterIconTrafico {
    margin-bottom: 24px;
    justify-content: center;
  }

  .cardContainerTrafico .table-responsive {
    /* mantiene un alto fijo y scroll en Y, y también scroll en X */
    height: calc(100dvh - 186px);
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    /* para que sticky se refiera a este contenedor */
  }

  .cardContainerTrafico .table-responsive table {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    /* fuerza scroll horizontal si cabe */
    table-layout: fixed;
    /* respeta los anchos que defines en cada <th> */
    border-collapse: collapse;
  }

  .cardContainerTrafico .table-responsive th,
  .cardContainerTrafico .table-responsive td {
    min-width: 0 !important;
    max-width: none;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .cardContainerTrafico .table-responsive th:nth-child(1),
  .cardContainerTrafico .table-responsive td:nth-child(1) {
    width: 16% !important;
  }

  .cardContainerTrafico .table-responsive th:nth-child(2),
  .cardContainerTrafico .table-responsive td:nth-child(2) {
    width: 14% !important;
  }

  /* fija el header al top del contenedor .table-responsive */
  .cardContainerTrafico .table-responsive thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    /* por encima de las filas */
    background-color: #006699;
    /* mismo fondo que tu .FondoHeaderTabla2 */
    color: #fff;
  }


  .containerReporteContratoSeguimiento>table {
    width: 100%;
    /* Asegura que la tabla ocupe todo el ancho del contenedor */
    table-layout: fixed;
    /* Hace que las celdas tengan un tamaño fijo, evitando que se estiren */
  }
}

/* Tráfico ocupa el viewport y deja el desplazamiento vertical a la grilla. */
@media (min-width: 768px) {
  html.table-page-lock,
  body:has(.trafico-page),
  body:has(.solicitudes-page) {
    overflow-y: hidden;
  }

  body:has(.trafico-page) #root,
  body:has(.trafico-page) .wrapper,
  .trafico-page {
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
  }

  .trafico-page .layout-container,
  .trafico-page .layout-page,
  .trafico-page .content-wrapper {
    min-height: 0;
  }

  .trafico-page .layout-page {
    height: 100%;
  }

  .trafico-page .content-wrapper {
    height: auto;
    flex: 1 1 auto;
  }

  .trafico-page .content-wrapper {
    overflow: hidden;
  }

  .trafico-page .container-fluid.container-p-y {
    min-width: 0;
    min-height: 0;
    height: 100%;
    overflow: hidden;
  }

  .trafico-page .trafico-table-freeze-wrapper {
    overflow-x: hidden !important;
  }

  .trafico-page .trafico-table-freeze-2 {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
  }

  .trafico-page .trafico-live-stack {
    height: calc(100dvh - 186px);
    min-height: 0;
  }

}

/* Repsonsive */
@media (max-width: 768px) {

  .filterTraficCss {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .FilterSearchTraficc {
    margin-bottom: 24px;
  }

  .countersColorsTrafico {
    justify-content: center;
    /* Por ejemplo, alineados a la izquierda */
    gap: 32px 20px;
    margin-bottom: 24px;
    margin-top: 12px;
    /* Distinto gap horizontal y vertical */
  }

  .containerCardsTrafico {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
  }

  .containerCardsTrafico .ContainerContratoInitial {
    padding: 15px;
  }

  .containerCardsTrafico .ContainerContratoInitial .infoEmpresaContrato span {
    font-weight: 700;
  }

  .opcionesContrato {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .moreInfoStyles {
    background-color: #e6eef7;
    padding: 12px;
    border-radius: 12px;
    margin-top: 24px;
  }

  .moreInfoStyles span {
    font-weight: 700;
  }

  .controlHistoricoH4 {
    margin-top: 50px;
  }

  .containerReporteContratoSeguimiento {
    width: 100%;
    overflow-x: scroll;
  }

  .tableReporteContratoSeguimiento .sticky-header {
    width: 100px;
  }

.containerReporteContratoSeguimientoHistorico {
    width: 100%;
    overflow-x: scroll;
  }

  .tableReporteContratoSeguimientoHistorico .sticky-header {
    width: 100px;
  }

  .controlDeviceTitle {
    margin-top: 50px;
  }

  .cardControlDevice {
    width: 100%;
    overflow-x: scroll;
  }

  .usuarios .table-responsive {
    width: 100% !important;
    border-radius: 12px;
  }

  .usuarios .table-responsive .table {
    width: 1290px !important;
    overflow-x: auto;
  }

  .usuarios .buttonUsuarios button {
    width: 100% !important;
    margin-top: 12px;
  }

  .rolesTable {
    width: 100% !important;

  }

  /* mantiene scroll horizontal si el ancho total supera el viewport */
  .rolesTable .table {
    min-width: 490px;
    overflow-x: scroll;
  }

  /* evita colapso extremo */
  .rolesTable .table thead th:nth-child(1),
  .rolesTable .table tbody td:nth-child(1) {
    width: 80px;
  }

  /* ID más compacto */
  .rolesTable .table thead th:nth-child(3),
  .rolesTable .table tbody td:nth-child(3) {
    width: 90px;
  }

  .buttonsRole {
    display: flex;
    flex-direction: column !important;
    gap: 12px;
  }

  .buttonsRole button {
    width: 100% !important;
    box-sizing: border-box;
    text-align: center;
    font-size: 12px;
  }



  /* OPCIONES más compacta */


}

.en-vivo-panel {
  min-height: 420px;
  padding: 14px;
  background:
    radial-gradient(1200px 280px at 8% -20%, rgba(28, 145, 255, 0.12), transparent 60%),
    linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 14px;
  border: 1px solid #d5e3f2;
}

.en-vivo-layout {
  display: grid;
  grid-template-columns: minmax(320px, 1.6fr) minmax(280px, 1fr);
  gap: 16px;
  align-items: start;
  width: 100%;
}

.en-vivo-left,
.en-vivo-right {
  min-height: 420px;
  width: 100%;
  min-width: 0;
}

.en-vivo-card {
  background: linear-gradient(140deg, #1b2432 0%, #2d2d2d 100%);
  color: #f8fbff;
  border: 1px solid rgba(90, 177, 255, 0.25);
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.32);
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
}

.en-vivo-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.en-vivo-title-text {
  line-height: 1;
}

.en-vivo-title .en-vivo-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e11d48;
  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);
  animation: en-vivo-pulse 1.2s ease-out infinite;
}

.en-vivo-text {
  font-size: 12px;
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.85);
}

.en-vivo-contrato {
  font-size: 12px;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.75);
}

.en-vivo-preview {
  position: relative;
  background: #050b14;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  margin-bottom: 12px;
  border: 1px solid rgba(111, 193, 255, 0.2);
  max-width: 100%;
}

.en-vivo-preview video,
.en-vivo-iframe,
.en-vivo-media {
  width: 100%;
  height: 100%;
  display: block;
}

.en-vivo-media {
  object-fit: contain;
}

.en-vivo-iframe {
  border: 0;
}

.en-vivo-overlay-actions {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  gap: 8px;
}

.en-vivo-fullscreen-btn,
.en-vivo-pip-btn {
  background: rgba(15, 23, 42, 0.8);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  width: 32px;
  height: 32px;
  padding: 0;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.en-vivo-preview.is-fullscreen {
  aspect-ratio: auto;
  border-radius: 0;
  margin-bottom: 0;
}

.en-vivo-preview.is-fullscreen video {
  object-fit: contain;
}

.en-vivo-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  background: rgba(0, 0, 0, 0.4);
  text-align: center;
  padding: 8px;
}

.en-vivo-loader {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  padding: 8px;
  z-index: 2;
  pointer-events: none;
}

.en-vivo-spinner {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  animation: en-vivo-spin 0.9s linear infinite;
}

@keyframes en-vivo-spin {
  to {
    transform: rotate(360deg);
  }
}

.en-vivo-actions {
  display: flex;
  gap: 8px;
}

.en-vivo-stream-control {
  display: inline-flex;
  align-items: stretch;
  border-radius: 10px;
  overflow: hidden;
  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);
  border: 1px solid #3aa2de;
  min-height: 36px;
  box-shadow: 0 8px 20px rgba(27, 132, 197, 0.25);
}

.en-vivo-stream-btn {
  border: 0;
  background: transparent;
  color: #fff;
  padding: 0 16px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.en-vivo-stream-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.en-vivo-stream-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: -2px;
}

.en-vivo-duration-select {
  border: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  background: transparent;
  color: #fff;
  padding: 0 32px 0 12px;
  min-width: 74px;
  cursor: pointer;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #fff 50%), linear-gradient(135deg, #fff 50%, transparent 50%);
  background-position: calc(100% - 15px) 13px, calc(100% - 10px) 13px;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
}

.en-vivo-duration-select:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: -2px;
}

.en-vivo-duration-select option {
  color: #0f172a;
}

.en-vivo-error {
  font-size: 11px;
  color: #ffb3b3;
  margin-bottom: 8px;
}

.en-vivo-stream-carousel-wrap {
  margin-bottom: 10px;
}

.en-vivo-stream-carousel-title {
  font-size: 12px;
  color: #d1d5db;
  margin-bottom: 6px;
}

.en-vivo-stream-carousel {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
}

.en-vivo-stream-thumb {
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(17, 24, 39, 0.7);
  border-radius: 8px;
  padding: 6px;
  min-width: 170px;
  width: 170px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.en-vivo-stream-thumb:hover {
  border-color: rgba(59, 130, 246, 0.8);
}

.en-vivo-stream-thumb.is-active {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.45) inset;
}

.en-vivo-stream-thumb-frame {
  width: 100%;
  height: 92px;
  border: 0;
  border-radius: 6px;
  background: #000;
  pointer-events: none;
}

.en-vivo-stream-thumb-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0b2034 0%, #12395f 100%);
  color: #e2f2ff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
}

.en-vivo-stream-thumb-label {
  font-size: 11px;
  color: #e5e7eb;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.en-vivo-tracking {
  background: #ffffff;
  border-radius: 14px;
  padding: 16px;
  color: #1f2a3a;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
  border: 1px solid #d7e5f3;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
}

.modal .en-vivo-panel {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.modal .en-vivo-layout {
  align-items: stretch;
}

.modal .en-vivo-left,
.modal .en-vivo-right {
  min-height: 0;
}

.en-vivo-tracking-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.en-vivo-tracking-toggle {
  display: none;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}

.en-vivo-tracking-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
}

.en-vivo-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}

.en-vivo-kpi {
  background: #0b2234;
  color: #fff;
  border-radius: 8px;
  padding: 10px 12px;
}

.en-vivo-kpi-label {
  font-size: 11px;
  opacity: 0.7;
  margin-bottom: 4px;
}

.en-vivo-kpi-value {
  font-size: 13px;
  font-weight: 700;
}

.en-vivo-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  font-size: 12px;
  margin-bottom: 12px;
  color: #44596f;
}

.en-vivo-info-grid span {
  font-weight: 700;
  color: #0f172a;
}

.en-vivo-tab-title {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.en-vivo-counter {
  margin-left: 8px;
  font-weight: 600;
  color: #0b5c8f;
}

.en-vivo-refresh-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.en-vivo-refresh-icon {
  font-size: 12px;
}

.en-vivo-refresh-spinner {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(15, 23, 42, 0.25);
  border-top-color: #0b5c8f;
  animation: en-vivo-spin 0.9s linear infinite;
}

.en-vivo-table {
  border: 1px solid #d8e6f3;
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 360px;
  width: 100%;
  background: #fdfefe;
}

.en-vivo-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.en-vivo-table th,
.en-vivo-table td {
  padding: 8px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

.en-vivo-table th {
  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 2;
}

.en-vivo-table tbody tr:hover {
  background: #eff7ff;
}

.en-vivo-file-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #bfd4ea;
  border-radius: 8px;
  background: #f7fbff;
  color: #0b5c8f;
  cursor: pointer;
}

.en-vivo-file-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.en-vivo-empty {
  text-align: center;
  padding: 16px;
  color: #64748b;
}

@media (max-width: 992px) {
  .en-vivo-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .en-vivo-panel {
    padding: 12px;
  }

  .en-vivo-card,
  .en-vivo-tracking {
    padding: 12px;
  }

  .en-vivo-kpis {
    grid-template-columns: 1fr;
  }

  .en-vivo-kpi {
    text-align: left;
  }

  .en-vivo-info-grid {
    grid-template-columns: 1fr;
  }

  .en-vivo-table table {
    min-width: 520px;
  }
}

@media (max-width: 576px) {
  .en-vivo-panel {
    padding: 8px;
  }

  .en-vivo-layout {
    gap: 12px;
  }

  .en-vivo-card,
  .en-vivo-tracking {
    padding: 10px;
    border-radius: 10px;
  }

  .en-vivo-preview {
    margin-bottom: 10px;
  }

  .en-vivo-overlay-actions {
    right: 8px;
    bottom: 8px;
    flex-direction: column;
  }

  .en-vivo-fullscreen-btn,
  .en-vivo-pip-btn {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .en-vivo-kpi {
    padding: 8px 10px;
  }

  .en-vivo-kpi-value {
    font-size: 12px;
  }

  .en-vivo-table table {
    min-width: 480px;
  }

  .en-vivo-table {
    -webkit-overflow-scrolling: touch;
  }

  .en-vivo-tracking-toggle {
    display: inline-flex;
  }

  .en-vivo-tracking.is-collapsed .en-vivo-kpis,
  .en-vivo-tracking.is-collapsed .en-vivo-info-grid,
  .en-vivo-tracking.is-collapsed .en-vivo-tab-title,
  .en-vivo-tracking.is-collapsed .en-vivo-table {
    display: none;
  }

  .en-vivo-tracking.is-collapsed {
    padding-bottom: 12px;
  }

  .en-vivo-actions {
    width: 100%;
  }

  .en-vivo-stream-control {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .en-vivo-stream-btn {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .en-vivo-duration-select {
    flex: 0 0 auto;
    box-sizing: border-box;
  }
}

/* Pulso suave con halo usando el color primario de MDB (fallback a azul) */
@keyframes pulse-shadow {
  0% {
    box-shadow: 0 0 0 0 rgba(var(--mdb-primary-rgb, 13, 110, 253), .45);
  }

  70% {
    box-shadow: 0 0 0 12px rgba(var(--mdb-primary-rgb, 13, 110, 253), 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(var(--mdb-primary-rgb, 13, 110, 253), 0);
  }
}

@keyframes pulse-scale {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }
}

.btn-pulse {
  animation: pulse-shadow 1.6s ease-out infinite, pulse-scale 1.6s ease-in-out infinite;
  will-change: transform, box-shadow;
}

.live-fab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.live-indicator {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #ff2d2d;
  box-shadow: 0 0 0 0 rgba(255, 45, 45, 0.6);
  animation: live-dot-pulse 1.4s ease-out infinite;
}

.live-fab.is-live .live-indicator {
  background: #fff;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  animation: live-dot-pulse-white 1.4s ease-out infinite;
}

@keyframes live-dot-pulse {
  0% {
    transform: scale(0.85);
    box-shadow: 0 0 0 0 rgba(255, 45, 45, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 45, 45, 0);
  }
  100% {
    transform: scale(0.85);
    box-shadow: 0 0 0 0 rgba(255, 45, 45, 0);
  }
}

@keyframes live-dot-pulse-white {
  0% {
    transform: scale(0.85);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    transform: scale(0.85);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

/* Respeta accesibilidad: sin animaciones para quien lo pida */
@media (prefers-reduced-motion: reduce) {
  .btn-pulse {
    animation: none;
  }
}



/* Estilos para los dropdowns */
/* .dropbtn {
  padding: 10px;
  font-size: 16px;
  border: none;
  cursor: pointer;
} */

/* Estilos para el contenedor del dropdown */
/* .dropdown {
  position: relative;
  display: inline-block;
} */

/* Estilos para las opciones del dropdown */
/* .dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
} */

/* Estilos para las opciones del dropdown al estar activo */
/* .dropdown-content.active {
  display: block;
} */

/* Estilos para las opciones del dropdown */
/* .dropdown-content span {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
} */

/* Estilos para las opciones del dropdown al pasar el cursor sobre ellas */
/* .dropdown-content span:hover {
  background-color: #f1f1f1;
} */

.seguimiento-links-row {
  margin-bottom: 14px !important;
}

/* Reserva espacio para que el hover de los botones no quede recortado arriba. */
.seguimiento-links-row > div {
  padding: 7px 4px 4px !important;
}

.seguimiento-links a {
  color: #2368ff;
  font-weight: 500;
  text-decoration: none;
}

.seguimiento-links a:hover {
  text-decoration: underline;
}

.seguimiento-links {
  align-items: center;
  gap: 8px;
  width: max-content;
}

.seguimiento-links .seguimiento-action-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 6px 11px;
  border: 1px solid #d7e5f2;
  border-radius: 10px;
  background: #f7fbff;
  color: #195d8d;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  transition: background-color .18s ease, border-color .18s ease, transform .18s ease;
}

.seguimiento-links .seguimiento-action-link:hover {
  border-color: #8ec3e8;
  background: #eaf5fd;
  text-decoration: none;
  transform: translateY(-1px);
}

.seguimiento-links .seguimiento-action-link > i {
  display: inline-block !important;
  font-size: 18px;
  line-height: 1;
}

/* Estos enlaces son acciones, no pestañas: ninguno debe aparecer activo por defecto. */
.seguimiento-links .seguimiento-action-link:first-child {
  border-color: #d7e5f2 !important;
  background: #f7fbff !important;
  color: #195d8d !important;
  box-shadow: none !important;
}

.seguimiento-links .seguimiento-action-link:first-child:hover {
  border-color: #8ec3e8 !important;
  background: #eaf5fd !important;
  color: #195d8d !important;
}

.seguimiento-topbar {
  border-radius: 12px;
  background: linear-gradient(120deg, #0b5c8f 0%, #1b84c5 100%);
  box-shadow: 0 10px 28px rgba(11, 92, 143, 0.2);
}

.seguimiento-kpis .seguimiento-kpi-card {
  font-family: "IBM Plex Mono", Consolas, monospace;
  font-size: 15px;
  color: #fff;
  text-align: center;
  border-radius: 12px;
  padding: 6px 10px;
  background: linear-gradient(180deg, #071a28 0%, #02070d 100%);
  border: 1px solid #11344a;
  box-shadow: inset 0 0 0 1px rgba(88, 167, 255, 0.14);
}

.seguimiento-map {
  border: 1px solid #c9d9e7;
  border-radius: 14px;
  min-height: 500px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.seguimiento-panel {
  border: 1px solid #d6e3ef;
  border-radius: 14px;
  padding: 10px;
  background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);
}

.seguimiento-switches {
  margin-top: 8px;
  margin-bottom: 8px;
}

.seguimiento-meta-card {
  border: 1px solid #d6e3ef;
  border-radius: 12px;
  background: #fff;
  padding: 8px 10px;
}

.seguimiento-meta-info-button {
  position: absolute;
  top: 8px;
  right: 10px;
  z-index: 2;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #007bff;
  background: #eef6ff;
  box-shadow: 0 6px 14px rgba(0, 123, 255, 0.12);
  cursor: pointer;
}

.seguimiento-actions-info-button {
  display: none !important;
}

.seguimiento-meta-info-button:hover,
.seguimiento-meta-info-button:focus-visible {
  background: #dceeff;
  outline: 2px solid rgba(0, 123, 255, 0.25);
  outline-offset: 2px;
}

/* Datos adicionales alineados con las columnas reales de la grilla de Tráfico. */
.trafico-expanded-details {
  display: flex;
  justify-content: space-around;
  gap: 16px;
  width: calc(100% + 16px);
  margin-left: -8px;
  min-width: 0;
  align-items: start;
  box-sizing: border-box;
}

.trafico-expanded-details > div {
  flex: 0 1 auto;
  min-width: 0;
  padding: 0 8px;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.trafico-expanded-contract {
  flex-basis: 26%;
}

.trafico-expanded-container {
  flex-basis: 26%;
}

.trafico-expanded-route {
  flex-basis: 40%;
}

@media (max-width: 1399px) {
  .trafico-expanded-details {
    gap: 10px;
  }

  .trafico-expanded-details > div {
    flex-basis: 30%;
  }
}

.seguimiento-table-card {
  border: 1px solid #d6e3ef;
  border-radius: 12px;
  background: #f9fcff;
  padding: 8px;
}

.seguimiento-table-card .tabs {
  border-bottom: 1px solid #d6e3ef !important;
  gap: 8px !important;
}

.seguimiento-table-card .tab {
  border-radius: 10px !important;
  padding: 7px 14px !important;
  font-weight: 600;
}

.seguimiento-table-card .tableReporteContratoSeguimiento {
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  min-width: 100%;
  table-layout: fixed;
}

.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr:hover {
  cursor: pointer;
}

.seguimiento-historico-app {
  background:
    radial-gradient(1100px 280px at 5% -15%, rgba(28, 163, 236, 0.12), transparent 60%),
    linear-gradient(180deg, #f7fbff 0%, #eef4fb 100%);
  border: 1px solid #d7e5f2;
  border-radius: 14px;
  padding: 10px 12px;
}

.seguimiento-historico-app .seguimiento-links-row {
  margin-bottom: 14px !important;
}

.seguimiento-historico-app .seguimiento-links {
  background: transparent;
  border: 0;
  border-radius: 0;
  padding: 0;
}

.seguimiento-historico-app .seguimiento-topbar {
  border-radius: 12px;
  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);
  box-shadow: 0 10px 24px rgba(11, 92, 143, 0.22);
  border: 1px solid #2f92cf;
}

.seguimiento-historico-app .seguimiento-kpi-card {
  border-radius: 12px;
  border: 1px solid #153650;
  background: linear-gradient(180deg, #061725 0%, #02080f 100%) !important;
  box-shadow: inset 0 0 0 1px rgba(96, 175, 255, 0.12);
  min-height: 76px;
}

.seguimiento-historico-app .seguimiento-map {
  border-radius: 14px;
  min-height: 500px;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.12);
  border: 1px solid #cddcea !important;
}

.seguimiento-historico-app .seguimiento-panel {
  border: 1px solid #d2e2f1;
  border-radius: 14px;
  background: #ffffff;
  padding: 10px 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.seguimiento-historico-app .seguimiento-table-card {
  border: 1px solid #d3e2f1;
  border-radius: 12px;
  background: #f9fcff;
  padding: 8px;
}

.seguimiento-historico-app .tabs {
  border-bottom: 1px solid #d3e2f1;
  gap: 8px;
}

.seguimiento-historico-app .tab {
  border-radius: 10px !important;
  border: 1px solid #c8dbeb;
  background: #f2f8ff;
  color: #1d5780;
}

.seguimiento-historico-app .tab.active {
  background: linear-gradient(135deg, #0b5c8f, #1b84c5) !important;
  color: #fff;
  border-color: transparent;
  box-shadow: 0 8px 20px rgba(27, 132, 197, 0.24);
}

.seguimiento-historico-app .tableReporteContratoSeguimiento th {
  min-height: 46px;
  padding: 10px 8px !important;
  font-size: 12px;
  vertical-align: middle;
}

.seguimiento-historico-app .tableReporteContratoSeguimiento td {
  min-height: 42px;
  padding: 8px 8px !important;
  vertical-align: middle;
}
.base-modal-xxl-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.base-modal-xxl-header-content > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/Css/trafico.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;EACzB,mCAAmC;EACnC,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;;;;;EAKE;AACF;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,OAAO;AACT;;AAEA;;EAEE,WAAW;EACX,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;mCAEmC;AACnC;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,+BAA+B;EAC/B,oDAAoD;AACtD;;AAEA;;EAEE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA,8CAA8C;AAC9C;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB;mCACiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB;mCACiC;AACnC;;AAEA;EACE,sBAAsB;;AAExB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gDAAgD;EAChD,iCAAiC;EACjC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,yEAAyE;AACzE;;;;EAIE,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,+CAA+C;EAC/C,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;AACb;;AAEA,6BAA6B;AAC7B;;EAEE,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,wDAAwD;AACxD;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA,iBAAiB;;AAEjB;;EAEE,YAAY;AACd;;AAEA,iFAAiF;AACjF;;;;EAIE,8BAA8B;EAC9B,uCAAuC;EACvC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iEAAiE;EACjE,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;AAChB;;AAEA,qDAAqD;AACrD;;;;wEAIwE;AACxE;;GAEG;AACH;EACE,gEAAgE;EAChE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,iCAAiC;EACjC,WAAW;EACX,iCAAiC;EACjC,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;;;AAIA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,yBAAyB;EACzB,gDAAgD;EAChD,YAAY;AACd;;;;AAIA;;;;;+BAK+B;;AAE/B,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,yBAAyB,EAAE,oCAAoC;EAC/D,iBAAiB;AACnB;;AAEA;;+BAE+B;AAC/B;EACE,gBAAgB;EAChB,MAAM;EACN,qBAAqB,UAAU,4BAA4B;EAC3D,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;+BAE+B;AAC/B;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB,eAAe,sCAAsC;EACrE,4BAA4B;AAC9B;;AAEA;;+BAE+B;AAC/B;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;+BAG+B;AAC/B;EACE,gBAAgB;EAChB,OAAO;EACP,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;;EAEE,8CAA8C;AAChD;;;AAGA,gDAAgD;AAChD;kCACkC,YAAY,EAAE,gBAAgB,EAAE;;AAElE;kCACkC,YAAY,EAAE,gBAAgB,EAAE;;AAElE;kCACkC,YAAY,EAAE,gBAAgB,EAAE;;AAElE;kCACkC,YAAY,EAAE,gBAAgB,EAAE;;AAElE;uEACuE;AACvE;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;+BAK+B;;AAE/B;;;qCAGqC;;AAErC;;8BAE8B;;AAE9B,kBAAkB;AAClB;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,oCAAoC;AACtC;;AAEA,mCAAmC;AACnC;;;;;;;;EAQE,gBAAgB,aAAa,qBAAqB;EAClD,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,8CAA8C;AAC9C;;;;EAIE,WAAW;EACX,oCAAoC;EACpC,WAAW;AACb;;AAEA,+BAA+B;AAC/B;qDACqD,OAAO,EAAE;;AAE9D;qDACqD,WAAW,EAAE;;AAElE;qDACqD,WAAW,EAAE;;AAElE;qDACqD,WAAW,EAAE;;AAElE,yCAAyC;AACzC;;EAEE,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB,gBAAgB,mBAAmB,EAAE;;;AAGrC;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qEAAqE;EACrE,iBAAiB;EACjB,qDAAqD;EACrD,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qEAAqE;EACrE,iBAAiB;EACjB,qDAAqD;EACrD,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uCAAuC;AACzC;;AAEA,yEAAyE;AACzE;EACE,yBAAyB;EACzB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;;AAIA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6EAA6E;AAC/E;;;AAGA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,qBAAqB;IACrB,wCAAwC;EAC1C;AACF;;AAEA,KAAK;;AAEL;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,YAAY;;AAEd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mDAAmD;AACrD;;;AAGA,qEAAqE;AACrE;EACE;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;;;;AAKA;EACE;;IAEE,2BAA2B;IAC3B,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,+DAA+D;IAC/D,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;EACnD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,gDAAgD;IAChD,yBAAyB;EAC3B;;EAEA;;IAEE,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA,2DAA2D;EAC3D;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,0CAA0C;IAC1C,WAAW;EACb;;;EAGA;IACE,WAAW;IACX,4DAA4D;IAC5D,mBAAmB;IACnB,uEAAuE;EACzE;AACF;;AAEA,6EAA6E;AAC7E;EACE;;;IAGE,kBAAkB;EACpB;;EAEA;;;IAGE,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,aAAa;EACf;;AAEF;;AAEA,eAAe;AACf;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;AAEF;IACI,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;;EAExB;;EAEA,oEAAoE;EACpE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,0BAA0B;EAC1B;;IAEE,WAAW;EACb;;EAEA,oBAAoB;EACpB;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;;;EAIA,0BAA0B;;;AAG5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb;;qDAEmD;EACnD,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,iCAAiC;EACjC,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uHAAuH;EACvH,mEAAmE;EACnE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8CAA8C;EAC9C,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,mEAAmE;EACrE;;EAEA;IACE,oEAAoE;EACtE;;EAEA;IACE,iEAAiE;EACnE;AACF;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,qFAAqF;EACrF,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,sDAAsD;AACxD;;AAEA;EACE;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;EACA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,4CAA4C;EAC9C;EACA;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;EACA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,eAAe;EACjB;AACF;;;;AAIA,+BAA+B;AAC/B;;;;;GAKG;;AAEH,4CAA4C;AAC5C;;;GAGG;;AAEH,2CAA2C;AAC3C;;;;;;;GAOG;;AAEH,2DAA2D;AAC3D;;GAEG;;AAEH,2CAA2C;AAC3C;;;;;;GAMG;;AAEH,0EAA0E;AAC1E;;GAEG;;AAEH;EACE,8BAA8B;AAChC;;AAEA,gFAAgF;AAChF;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mFAAmF;AACrF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;qDAEmD;EACnD,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wEAAwE;EACxE,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gEAAgE;EAChE,WAAW;EACX,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".FondoHeaderTabla2 {\n  background-color: #006699;\n  font-size: 16px;\n}\n\n.FondoHeaderTabla3 {\n  background-color: #006699;\n  font-size: 12px !important;\n}\n\n.object-box {\n  position: absolute;\n  border: 2px solid blue;\n  z-index: 9999;\n}\n\n.object-box2 {\n  position: absolute;\n  border: 2px solid red;\n  z-index: 9999;\n}\n\n.image-container {\n  position: relative;\n}\n\n.countersColorsTrafico {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  align-self: flex-start;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.countersColorsTrafico>div {\n  margin-right: 12px;\n\n}\n\n.countersColorsTrafico>.red {\n  background-color: #E02B28;\n}\n\n.countersColorsTrafico>.yellow {\n  background-color: #E0A019;\n}\n\n.countersColorsTrafico>.green {\n  background-color: #5DE02B;\n}\n\n.countersColorsTrafico>.blue {\n  background-color: #006699;\n}\n\n.countersColorsTrafico>.trans {\n  background-color: transparent;\n}\n\n.trafico-alerts-toolbar {\n  transform: translateX(-28px);\n}\n\n.trafico-company-filter {\n  width: 300px;\n  min-width: 260px;\n  position: relative;\n  z-index: 120;\n  align-self: center;\n  margin-bottom: 0;\n}\n\n.trafico-company-select__control {\n  height: 38.94px;\n  min-height: 38.94px;\n  border-color: #cbd5df !important;\n  box-shadow: none !important;\n  font-size: 14px;\n}\n\n.trafico-company-select__value-container {\n  height: 38.94px;\n  padding: 0 10px;\n  align-items: center;\n}\n\n.trafico-company-select__indicators {\n  height: 38.94px;\n}\n\n.trafico-company-select__control:hover,\n.trafico-company-select__control--is-focused {\n  border-color: #6c9fbd !important;\n}\n\n.trafico-company-select__menu {\n  z-index: 2000 !important;\n}\n\n.trafico-company-select__option--is-focused {\n  background: #e7f3fa;\n  color: #17324a;\n}\n\n.trafico-company-select__option--is-selected {\n  background: #0874a8;\n}\n\n/* Encabezado fijo al hacer scroll */\n#tablaTRAF thead th {\n  position: sticky;\n  top: 0;\n  z-index: auto;\n  /* por encima de las filas */\n  background-color: #006699;\n  /* reproduce tu FondoHeaderTabla2 */\n  color: #fff;\n}\n\n/* Quita el z-index elevado de las celdas del body para no tapar el thead */\n.cardContainerTrafico #tablaTRAF tbody td {\n  z-index: auto;\n}\n\n/* Grilla de Tráfico: las filas se desplazan verticalmente dentro de la tabla. */\n.trafico-table-freeze-wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #8ea9bd transparent;\n  -webkit-overflow-scrolling: touch;\n}\n\n/*\n * En portátiles/tablets grandes se conserva la tabla de escritorio, pero sus\n * columnas no caben siempre en el viewport. En ese rango el wrapper debe ser\n * la única superficie de scroll horizontal. El escritorio amplio conserva el\n * comportamiento actual y las tarjetas responsive (<= 1199px) no se tocan.\n */\n@media (min-width: 1200px) and (max-width: 1599px) {\n  .trafico-table-freeze-wrapper {\n    overflow-x: auto !important;\n  }\n\n  .cardContainerTrafico .table-responsive .trafico-table-freeze-2 {\n    width: max-content !important;\n    min-width: 100% !important;\n    max-width: none !important;\n  }\n}\n\n.trafico-table-freeze-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.trafico-table-freeze-wrapper::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.trafico-table-freeze-wrapper::-webkit-scrollbar-thumb {\n  border: 2px solid transparent;\n  border-radius: 999px;\n  background: #8ea9bd;\n  background-clip: padding-box;\n}\n\n.trafico-table-freeze-wrapper::-webkit-scrollbar-thumb:hover {\n  background-color: #5d819a;\n}\n\n.cardContainerTrafico .table-responsive .trafico-table-freeze-2 {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.trafico-table-freeze-2 th:nth-child(1),\n.trafico-table-freeze-2 td:nth-child(1) {\n  width: 220px;\n  min-width: 220px;\n}\n\n.trafico-table-freeze-2 th:nth-child(2),\n.trafico-table-freeze-2 td:nth-child(2) {\n  width: 210px;\n  min-width: 210px;\n}\n\n.trafico-table-freeze-2 tbody tr {\n  background-color: #fff;\n}\n\n.trafico-table-freeze-2 thead th:nth-child(-n + 2),\n.trafico-table-freeze-2 tbody td:nth-child(-n + 2):not([colspan]) {\n  position: sticky;\n  z-index: 20;\n  background-color: inherit;\n  background-clip: padding-box;\n}\n\n.trafico-table-freeze-2 thead th:nth-child(-n + 2) {\n  z-index: 30 !important;\n  background-color: #006699;\n}\n\n.trafico-table-freeze-2 th:nth-child(1),\n.trafico-table-freeze-2 td:nth-child(1):not([colspan]) {\n  left: 0;\n}\n\n.trafico-table-freeze-2 th:nth-child(2),\n.trafico-table-freeze-2 td:nth-child(2):not([colspan]) {\n  left: 220px;\n  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);\n}\n\n.trafico-table-freeze-2 thead th,\n.trafico-table-freeze-2 tbody td {\n  overflow-wrap: normal;\n  word-break: normal;\n}\n\n.trafico-table-freeze-2 thead th {\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.trafico-table-freeze-2 tbody td {\n  min-width: 42px;\n}\n\n.trafico-table-freeze-2 tbody td.trafico-ubic-gps-cell {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  min-width: 214px;\n  max-width: 214px;\n  vertical-align: top;\n}\n\n.trafico-table-freeze-2 tbody td.trafico-observaciones-cell {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  vertical-align: top;\n}\n\n.trafico-table-freeze-2 tbody td:nth-child(2) {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  overflow: visible !important;\n  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);\n}\n\n.trafico-device-link {\n  appearance: none;\n  position: relative;\n  display: inline-block;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  color: #006699;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.device-live-wrap:has(.custom-tooltip:hover),\n.device-live-wrap:has(.custom-tooltip:focus-within) {\n  position: relative;\n  z-index: 10000;\n}\n\n/* El tooltip vive dentro de la segunda columna fija. Elevar la fila y la\n   celda activa evita que las columnas siguientes o el encabezado sticky lo\n   cubran durante el hover/focus. */\n.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:hover),\n.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:focus-within) {\n  position: relative;\n  z-index: 1000;\n}\n\n.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:hover) td:nth-child(2),\n.trafico-table-freeze-2 tbody tr:has(.custom-tooltip:focus-within) td:nth-child(2) {\n  position: sticky;\n  z-index: 1100 !important;\n  overflow: visible !important;\n}\n\n.custom-tooltip,\n.custom-tooltip::after {\n  z-index: 100000 !important;\n}\n\n.trafico-device-link[data-tooltip]::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 8px);\n  z-index: 1000;\n  width: max-content;\n  max-width: 260px;\n  padding: 7px 9px;\n  border-radius: 6px;\n  background: #1f3448;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n  text-align: left;\n  white-space: normal;\n  opacity: 0;\n  pointer-events: none;\n  transform: translate(-50%, 4px);\n  transition: opacity 140ms ease, transform 140ms ease;\n}\n\n.trafico-device-link[data-tooltip]:hover::after,\n.trafico-device-link[data-tooltip]:focus-visible::after {\n  opacity: 1;\n  transform: translate(-50%, 0);\n}\n\n.trafico-device-link:hover,\n.trafico-device-link:focus-visible {\n  color: #004b73;\n}\n\n.trafico-device-link:focus-visible {\n  outline: 2px solid #006699;\n  outline-offset: 3px;\n  border-radius: 2px;\n}\n\n.trafico-table-freeze-2 tbody .trafico-placa-cell {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.trafico-camera-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.trafico-camera-button:hover {\n  background-color: rgba(0, 102, 153, 0.1);\n}\n\n.trafico-camera-button:focus-visible {\n  outline: 2px solid #006699;\n  outline-offset: 2px;\n}\n\n@media (min-width: 1400px) {\n  .trafico-table-freeze-wrapper {\n    overflow-x: hidden !important;\n  }\n\n  .cardContainerTrafico .table-responsive .trafico-table-freeze-2 {\n    width: 100%;\n    min-width: 0;\n    table-layout: fixed;\n  }\n\n  .trafico-table-freeze-2 th:nth-child(1),\n  .trafico-table-freeze-2 td:nth-child(1) {\n    width: 150px !important;\n    min-width: 150px !important;\n  }\n\n  .trafico-table-freeze-2 th:nth-child(2),\n  .trafico-table-freeze-2 td:nth-child(2) {\n    width: 145px !important;\n    min-width: 145px !important;\n  }\n\n  .trafico-table-freeze-2 th:nth-child(2),\n  .trafico-table-freeze-2 td:nth-child(2):not([colspan]) {\n    left: 150px;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(3) {\n    width: 42px !important;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(4) {\n    width: 86px !important;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(5) {\n    width: 115px !important;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(6) {\n    width: 155px !important;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(7) {\n    width: 110px !important;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(8) {\n    width: 190px !important;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(9),\n  .trafico-table-freeze-2 tbody td:nth-child(9) {\n    width: 145px !important;\n    min-width: 145px !important;\n    max-width: 145px !important;\n    white-space: normal;\n  }\n\n  .trafico-table-freeze-2 thead th:nth-child(n + 10):not(.trafico-tiempo-col) {\n    width: 38px !important;\n    min-width: 38px !important;\n    padding-left: 6px;\n    padding-right: 6px;\n  }\n\n  .trafico-table-freeze-2 thead th,\n  .trafico-table-freeze-2 tbody td {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .trafico-table-freeze-2 tbody td {\n    min-width: 0;\n  }\n\n  .trafico-table-freeze-2 th.trafico-ruta-col,\n  .trafico-table-freeze-2 td.trafico-ruta-col {\n    width: 155px !important;\n    max-width: 155px;\n  }\n\n  .trafico-table-freeze-2 thead th.trafico-tiempo-col,\n  .trafico-table-freeze-2 tbody td.trafico-tiempo-col {\n    width: 75px !important;\n    min-width: 75px !important;\n    max-width: 75px !important;\n    white-space: nowrap;\n  }\n\n  .trafico-table-freeze-2 tbody td.trafico-ubic-gps-cell {\n    min-width: 190px;\n    max-width: 190px;\n  }\n}\n\n.my-custom-collapse {\n  display: none;\n  /* Oculta las filas colapsables de forma predeterminada */\n}\n\n.my-custom-show {\n  display: table-row;\n  /* Muestra las filas colapsables cuando tienen la clase \"show\" */\n}\n\n/* Estilos adicionales según tus necesidades */\n.my-custom-collapse td {\n  /* Estilos para las celdas de las filas colapsables */\n}\n\n.counterItem {\n  position: relative;\n  border: 1px solid #ddd;\n  /* Un color de borde más suave */\n  border-radius: 8px;\n  padding: 5px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1),\n    0px 8px 15px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.counterItem.active {\n  background-color: #dfdddd;\n  box-shadow: 0px 4px 6px #006699,\n    0px 8px 15px rgba(0, 0, 0, 0.1);\n}\n\n.counterItem.inactive {\n  background-color: #fff;\n\n}\n\n/* ======== USUARIOS COMPONENT ======== */\n.usuarios .table-responsive {\n  overflow-x: auto;\n  /* scroll horizontal */\n  overflow-y: auto;\n  /* si también quieres vertical dentro del card */\n  -webkit-overflow-scrolling: touch;\n  max-height: 70vh;\n  /* opcional: limita alto del contenedor */\n}\n\n/* Evita que el contenido haga wrap y fuerce el ancho total de la tabla */\n.usuarios .table-responsive.text-nowrap,\n.usuarios .table-responsive .table,\n.usuarios .table-responsive .table th,\n.usuarios .table-responsive .table td {\n  white-space: wrap;\n}\n\n/* Contenedor con scroll y altura controlada */\n.rolesTable {\n  overflow-x: auto;\n  /* scroll horizontal cuando haga falta */\n  overflow-y: auto;\n  /* scroll vertical dentro de la card si crece */\n  -webkit-overflow-scrolling: touch;\n  /* inercia en iOS */\n  max-height: 60vh;\n  /* ajusta a tu gusto o quítalo */\n  border-radius: 8px;\n}\n\n/* Tabla estable con columnas predecibles */\n.rolesTable .table {\n  table-layout: fixed;\n  /* fija el layout y respeta anchos */\n  width: 100%;\n}\n\n/* Alineación y legibilidad */\n.rolesTable .table th,\n.rolesTable .table td {\n  vertical-align: middle;\n}\n\n/* Header pegado y legible (usa tu color de .FondoHeaderTabla2 si ya lo define) */\n.rolesTable .FondoHeaderTabla2 th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: #006699;\n  /* asegura contraste si tu clase no lo pone */\n  color: #ffffff;\n  white-space: nowrap;\n  /* encabezados en 1 línea */\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);\n}\n\n/* Columnas: ID chica, NOMBRE ocupa, OPCIONES compacta */\n.rolesTable .table thead th:nth-child(1),\n.rolesTable .table tbody td:nth-child(1) {\n  width: 110px;\n}\n\n.rolesTable .table thead th:nth-child(2),\n.rolesTable .table tbody td:nth-child(2) {\n  width: 100%;\n}\n\n/* NOMBRE crece */\n\n.rolesTable .table thead th:nth-child(3),\n.rolesTable .table tbody td:nth-child(3) {\n  width: 120px;\n}\n\n/* Por defecto traes 'text-nowrap' en el contenedor: anulamos para el contenido */\n.rolesTable.text-nowrap,\n.rolesTable .table,\n.rolesTable .table th,\n.rolesTable .table td {\n  white-space: normal !important;\n  /* permite múltiples líneas en celdas */\n  word-break: break-word;\n  /* rompe textos larguísimos */\n}\n\n/* Dropdowns no se cortan dentro del contenedor scrolleable */\n.rolesTable .dropdown.position-static {\n  position: static;\n}\n\n/* (Opcional) Header pegado mientras haces scroll vertical en el contenedor */\n.usuarios .FondoHeaderTabla2 th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  /* Asegura contraste si tu .FondoHeaderTabla2 no define bg/text */\n  background-color: #006699;\n  /* pon tu color de header si aplica */\n  color: #ffffff;\n}\n\n/* (Opcional) Sombrita cuando el header está pegado */\n/* .usuarios .FondoHeaderTabla2 th {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);\n}\n\n/* Evita que el dropdown se recorte dentro del contenedor con overflow */\n/* .usuarios .dropdown.position-static {\n  position: static;\n} */\n.btn.active {\n  box-shadow: 0px 4px 6px #006699, 0px 8px 15px rgba(0, 0, 0, 0.1);\n  background-color: #dfdddd;\n  color: #006699;\n}\n\n.notification {\n  display: flex;\n  align-items: center;\n  /* Alinear verticalmente */\n}\n\n/* Estilos para el badge circular palpitante */\n/* Estilos para el badge circular palpitante */\n.notification-badge {\n  position: absolute;\n  top: -5px;\n  /* Ajusta la posición del badge */\n  right: -5px;\n  /* Ajusta la posición del badge */\n  width: 15px;\n  /* Tamaño del badge */\n  height: 15px;\n  /* Tamaño del badge */\n  background-color: #006699;\n  /* Color del badge */\n  border-radius: 50%;\n  /* Hace que sea un círculo */\n  animation: pulse 1.5s infinite;\n  /* Hace que palpite */\n  border: 2px solid white;\n  /* Opcional: agrega un borde blanco */\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n\n  50% {\n    transform: scale(1.4);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n}\n\n\n\n.notificationCount {\n  position: absolute;\n  /* Posicionar el contador */\n  top: -25px;\n  /* Ajusta según sea necesario */\n  right: 10px;\n  /* Ajusta según sea necesario */\n  /* background-color: red; */\n  /* Fondo rojo */\n  color: #697A8D;\n  /* Color del texto */\n  border-radius: 50%;\n  /* Hacerlo circular */\n  width: 20px;\n  /* Ancho del círculo */\n  height: 20px;\n  /* Alto del círculo */\n  display: flex;\n  justify-content: center;\n  /* Centra el texto */\n  align-items: center;\n  font-weight: 700;\n  /* Centra el texto */\n  font-size: 17px;\n  /* Tamaño de la fuente */\n}\n\n\n.cardContainerTrafico .table-responsive thead th {\n  position: sticky;\n  top: 0;\n  /* z-index: 10; */\n  background-color: #006699;\n  /* o usa el mismo color que .FondoHeaderTabla2 */\n  color: white;\n}\n\n\n\n/* ==========================\n   TABLE FREEZE 4 (FIXED LEFT)\n   - 4 primeras columnas fijas\n   - THEAD sticky arriba\n   - Col 5+ del THEAD SIEMPRE por debajo de las 4 fijas\n   ========================== */\n\n/* Wrapper con scroll */\n.table-responsive-freeze {\n  position: relative;\n  overflow-x: auto;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  /* si usas altura fija en inline style, perfecto */\n}\n\n/* Tabla */\n.table-freeze-4 {\n  min-width: 2000px;\n  border-collapse: separate; /* necesario para sticky + sombras */\n  border-spacing: 0;\n}\n\n/* ==========================\n   THEAD sticky general (col 5+)\n   ========================== */\n.table-freeze-4 thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2 !important;         /* col 5+ queda por debajo */\n  background: #0b2f4a;\n  color: #fff;\n  /* opcional: evita transparencias raras */\n  background-clip: padding-box;\n  /* opcional: mejora lectura */\n  white-space: nowrap;\n}\n\n/* ==========================\n   TBODY normal (col 5+)\n   ========================== */\n.table-freeze-4 tbody td {\n  width: 100px;\n  overflow: visible;\n  white-space: normal;\n  background: #fff;              /* importante para tapar lo de atrás */\n  background-clip: padding-box;\n}\n\n/* ==========================\n   4 columnas fijas (TBODY)\n   ========================== */\n.table-freeze-4 tbody td:nth-child(1) {\n  position: sticky;\n  left: 0;\n  z-index: 10;\n  background: #fff;\n}\n.table-freeze-4 tbody td:nth-child(2) {\n  position: sticky;\n  left: 220px;\n  z-index: 10;\n  background: #fff;\n}\n.table-freeze-4 tbody td:nth-child(3) {\n  position: sticky;\n  left: 320px;\n  z-index: 10;\n  background: #fff;\n}\n.table-freeze-4 tbody td:nth-child(4) {\n  position: sticky;\n  left: 420px;\n  z-index: 10;\n  background: #fff;\n}\n\n/* ==========================\n   4 columnas fijas (THEAD)\n   - estas SIEMPRE por encima de col 5+\n   ========================== */\n.table-freeze-4 thead th:nth-child(1) {\n  position: sticky;\n  left: 0;\n  z-index: 50 !important;\n  background: #0b2f4a;\n}\n.table-freeze-4 thead th:nth-child(2) {\n  position: sticky;\n  left: 220px;\n  z-index: 50 !important;\n  background: #0b2f4a;\n}\n.table-freeze-4 thead th:nth-child(3) {\n  position: sticky;\n  left: 320px;\n  z-index: 50 !important;\n  background: #0b2f4a;\n}\n.table-freeze-4 thead th:nth-child(4) {\n  position: sticky;\n  left: 420px;\n  z-index: 50 !important;\n  background: #0b2f4a;\n}\n\n/* Separador visual después de la col 4 */\n.table-freeze-4 thead th:nth-child(4),\n.table-freeze-4 tbody td:nth-child(4) {\n  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);\n}\n\n\n/* Anchos fijos (ajusta a tus columnas reales) */\n.table-freeze-4 th:nth-child(1),\n.table-freeze-4 td:nth-child(1) { width: 220px; min-width: 220px; }\n\n.table-freeze-4 th:nth-child(2),\n.table-freeze-4 td:nth-child(2) { width: 135px; min-width: 135px; }\n\n.table-freeze-4 th:nth-child(3),\n.table-freeze-4 td:nth-child(3) { width: 100px; min-width: 100px; }\n\n.table-freeze-4 th:nth-child(4),\n.table-freeze-4 td:nth-child(4) { width: 150px; min-width: 150px; }\n\n/* Ajustes de la tabla de Histórico: los offsets deben coincidir con los\n   anchos reales y text-nowrap no debe impedir envolver el contenido. */\n.cardControlHistorico .table-freeze-4 thead th:nth-child(2),\n.cardControlHistorico .table-freeze-4 tbody td:nth-child(2) {\n  left: 220px;\n}\n\n.cardControlHistorico .table-freeze-4 thead th:nth-child(3),\n.cardControlHistorico .table-freeze-4 tbody td:nth-child(3) {\n  left: 355px;\n}\n\n.cardControlHistorico .table-freeze-4 thead th:nth-child(4),\n.cardControlHistorico .table-freeze-4 tbody td:nth-child(4) {\n  left: 455px;\n}\n\n.cardControlHistorico .table-freeze-4 tbody td {\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* ==========================\n   IMPORTANTE:\n   Si tienes reglas globales tipo:\n   tbody td { z-index: 999; }\n   te va a romper esto. Elimínalas o escópalas.\n   ========================== */\n\n/* ================================\n   SOLO TABLA DEVICES (id=tablaDevices)\n   - Ul.Contrato (col 2) no se encoge al hacer scroll\n   ================================ */\n\n/* =========================\n   Freeze 4 SOLO en #tablaDevices\n   ========================= */\n\n/* Header sticky */\n#tablaDevices thead th{\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: #006699 !important;\n}\n\n/* Columnas fijas (thead y tbody) */\n#tablaDevices.table-freeze-4 thead th:nth-child(1),\n#tablaDevices.table-freeze-4 tbody td:nth-child(1),\n#tablaDevices.table-freeze-4 thead th:nth-child(2),\n#tablaDevices.table-freeze-4 tbody td:nth-child(2),\n#tablaDevices.table-freeze-4 thead th:nth-child(3),\n#tablaDevices.table-freeze-4 tbody td:nth-child(3),\n#tablaDevices.table-freeze-4 thead th:nth-child(4),\n#tablaDevices.table-freeze-4 tbody td:nth-child(4) {\n  position: sticky;            /* <-- esto faltaba */\n  z-index: 10;\n  background: #fff;\n  background-clip: padding-box;\n}\n\n/* Encabezados de las fijas encima del resto */\n#tablaDevices.table-freeze-4 thead th:nth-child(1),\n#tablaDevices.table-freeze-4 thead th:nth-child(2),\n#tablaDevices.table-freeze-4 thead th:nth-child(3),\n#tablaDevices.table-freeze-4 thead th:nth-child(4) {\n  z-index: 50;\n  background-color: #006699 !important;\n  color: #fff;\n}\n\n/* Offsets (según tus anchos) */\n#tablaDevices.table-freeze-4 thead th:nth-child(1),\n#tablaDevices.table-freeze-4 tbody td:nth-child(1) { left: 0; }\n\n#tablaDevices.table-freeze-4 thead th:nth-child(2),\n#tablaDevices.table-freeze-4 tbody td:nth-child(2) { left: 220px; }\n\n#tablaDevices.table-freeze-4 thead th:nth-child(3),\n#tablaDevices.table-freeze-4 tbody td:nth-child(3) { left: 360px; }\n\n#tablaDevices.table-freeze-4 thead th:nth-child(4),\n#tablaDevices.table-freeze-4 tbody td:nth-child(4) { left: 460px; }\n\n/* Separador visual después de la col 4 */\n#tablaDevices.table-freeze-4 thead th:nth-child(4),\n#tablaDevices.table-freeze-4 tbody td:nth-child(4) {\n  box-shadow: 6px 0 6px -6px rgba(0, 0, 0, 0.35);\n}\n\n/* Ul.Contrato fijo de ancho */\n#tablaDevices thead th:nth-child(2),\n#tablaDevices tbody td:nth-child(2) {\n  width: 140px !important;\n  min-width: 140px !important;\n  max-width: 140px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Estabilidad general */\n#tablaDevices { table-layout: fixed; }\n\n\n.sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  /* Asegura que los encabezados se muestren por encima del contenido */\n  font-weight: bold;\n  /* Otras propiedades de estilo según tu preferencia */\n  background-color: #006699;\n  color: #ffffff;\n  font-size: 12px;\n}\n\n.sticky-header2 {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  /* Asegura que los encabezados se muestren por encima del contenido */\n  font-weight: bold;\n  /* Otras propiedades de estilo según tu preferencia */\n  background-color: #006699;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.background-class {\n  background-color: #FFCCCC;\n  /* Cambia este color al que prefieras */\n}\n\n.background-class2 {\n  background-color: black;\n  color: white;\n  /* Cambia este color al que prefieras */\n}\n\n.background-class3 {\n  background-color: #e0d96b;\n  color: black;\n  /* Cambia este color al que prefieras */\n}\n\n/* Hover con contraste propio para cada estado de la lista de mensajes. */\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr > td {\n  background-color: #ffffff;\n  color: #212529;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class > td {\n  background-color: #ffcccc;\n  color: #4a0b0b;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class2 > td {\n  background-color: #000000;\n  color: #ffffff;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class3 > td {\n  background-color: #e0d96b;\n  color: #211f00;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr:not(.background-class):not(.background-class2):not(.background-class3):hover,\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr:not(.background-class):not(.background-class2):not(.background-class3):hover > td {\n  background-color: #d6e9f8 !important;\n  color: #102a43 !important;\n  box-shadow: none !important;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class:hover,\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class:hover > td {\n  background-color: #e99a9a !important;\n  color: #4a0b0b !important;\n  box-shadow: none !important;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class2:hover,\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class2:hover > td {\n  background-color: #28323c !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class3:hover,\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr.background-class3:hover > td {\n  background-color: #c8bf3f !important;\n  color: #211f00 !important;\n  box-shadow: none !important;\n}\n\n.oculto {\n  visibility: collapse;\n  display: none;\n}\n\n.botonLetra {\n  font-size: 8px;\n}\n\n.custom-label {\n  font-size: 8px;\n}\n\n.custom-navbar {\n  background-color: #006699;\n  /* Reemplaza esto con tu color personalizado */\n  color: #fff;\n}\n\n.custom-switch .form-check-input:checked {\n  background-color: #2EA4B1;\n  /* Cambia este valor al color deseado */\n}\n\n.cardContainerTrafico .table-responsive table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n/* table {\n  table-layout: fixed;\n  width: 100%;\n} */\n\n.cardContainerTrafico tbody td {\n  width: 100px;\n  white-space: nowrap;\n  overflow: inherit !important;\n  white-space: initial;\n  z-index: 999;\n}\n\n.textSmall {\n  font-size: 12px;\n}\n\n.textSmall2 {\n  font-size: 10px;\n}\n\n.textCenterIcon {\n  width: 100%;\n  text-align: center;\n}\n\n#success-alert {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 30%;\n  z-index: 999;\n}\n\n#danger-alert {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 30%;\n  z-index: 999;\n}\n\n#dialog {\n  z-index: 1000;\n}\n\n.ui-dialog-titlebar {\n  background: #2EA4B1;\n  color: #ffffff;\n}\n\n\n\n#ModalGaleria .modal-content {\n  background-color: #ffffff;\n  z-index: 1000;\n}\n\n#ModalGaleria .sweet-alert-popup {\n  z-index: 1051;\n  /* Ajusta el z-index según sea necesario para que esté por encima del modal */\n}\n\n\n.dropdown {\n  position: relative;\n  z-index: 1000;\n}\n\n.containerSpaceMenu {\n  padding-left: 0;\n}\n\n.dropdown-item {\n  width: 100% !important;\n  display: block;\n  box-sizing: border-box;\n}\n\n.dropdown-item.dropdown-toggle-row {\n  width: 100% !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  text-align: left;\n  border: 0;\n  background: transparent;\n}\n\n.dropdown-item.dropdown-toggle-row > span:first-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.dropdown-item-chevron {\n  margin-left: auto;\n  flex: 0 0 auto;\n}\n\n.en-vivo-menu-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.en-vivo-live-dot {\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.en-vivo-live-dot::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e11d48;\n  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);\n  animation: en-vivo-pulse 1.2s ease-out infinite;\n}\n\n.live-counter-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid #e11d48;\n  color: #e11d48;\n  font-size: 0.7rem;\n  font-weight: 700;\n  background: #fff;\n}\n\n.live-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 8px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid #e11d48;\n  background: #fff;\n  color: #e11d48;\n  font-size: 0.7rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.live-pill-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #e11d48;\n  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);\n  animation: en-vivo-pulse 1.2s ease-out infinite;\n}\n\n.device-live-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.empresa-live-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n}\n\n.live-inline-section .live-inline-body {\n  padding: 12px 14px;\n}\n\n.live-inline-section .live-inline-grid {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 6px;\n}\n\n.trafico-live-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  height: calc(100vh - 180px);\n}\n\n.trafico-contracts-grid {\n  min-height: 220px;\n}\n\n.trafico-resize-handle {\n  height: 8px;\n  cursor: row-resize;\n  background: linear-gradient(180deg, #dbe6ef 0%, #c9d7e2 100%);\n  border-top: 1px solid #b9c9d6;\n  border-bottom: 1px solid #b9c9d6;\n}\n\n.trafico-resize-handle:hover {\n  background: linear-gradient(180deg, #cfddea 0%, #bacbd8 100%);\n}\n\n.trafico-live-section {\n  flex: 1 1 auto;\n  min-height: 160px;\n  display: flex;\n  width: 100%;\n}\n\n.trafico-live-section .live-inline-section {\n  margin-top: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.trafico-live-section .live-inline-body {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n\n.trafico-live-modal .live-inline-section {\n  margin-top: 0 !important;\n  width: 100%;\n}\n\n.trafico-live-modal .live-inline-body {\n  height: 100%;\n}\n\n.trafico-live-modal {\n  z-index: 11000 !important;\n}\n\n/* El panel de configuraciÃ³n debe quedar por encima del botÃ³n flotante Live. */\n.trafico-control-offcanvas {\n  z-index: 2100 !important;\n}\n\n@media (max-width: 768px) {\n  .trafico-live-modal {\n    left: 0 !important;\n    right: 0 !important;\n    top: 56px !important;\n    bottom: 0 !important;\n    width: auto !important;\n    height: auto !important;\n  }\n}\n\n@keyframes en-vivo-pulse {\n  0% {\n    transform: scale(0.9);\n    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);\n  }\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 6px rgba(225, 29, 72, 0);\n  }\n  100% {\n    transform: scale(0.9);\n    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0);\n  }\n}\n\n/*  */\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #dc3545;\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #28a745;\n}\n\n.ml-1 {\n  margin-left: 0.25rem;\n}\n\n\n.traficoTR>td {\n  padding: 5px;\n\n}\n\nspan {\n  cursor: pointer;\n}\n\n.scroll-offset {\n  scroll-margin-top: 40px;\n  /* Ajusta este valor según la altura de tu header */\n}\n\n\n/* Puedes ajustar los colores y la duración del parpadeo a tu gusto */\n@keyframes blink-bg {\n  0% {\n    background-color: #ffeb3b;\n    /* amarillo claro */\n  }\n\n  50% {\n    background-color: #fff9c4;\n    /* amarillo pastel */\n  }\n\n  100% {\n    background-color: #ffeb3b;\n    /* amarillo claro */\n  }\n}\n\n.blink-bg {\n  animation: blink-bg 1s ease-in-out 3;\n  /* 1s de animación, 3 repeticiones */\n}\n\n\n\n\n@media (max-width: 1400px) {\n  #tablaDevices.table-freeze-4 thead th,\n  #tablaDevices.table-freeze-4 tbody td {\n    position: static !important;\n    left: auto !important;\n  }\n  .containerReporteContratoSeguimiento {\n    width: 100%;\n    overflow-x: scroll;\n  }\n\n  #FilterIconTrafico {\n    margin-bottom: 24px;\n    justify-content: center;\n  }\n\n  .cardContainerTrafico .table-responsive {\n    /* mantiene un alto fijo y scroll en Y, y también scroll en X */\n    height: calc(100dvh - 186px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: relative;\n    /* para que sticky se refiera a este contenedor */\n  }\n\n  .cardContainerTrafico .table-responsive table {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    /* fuerza scroll horizontal si cabe */\n    table-layout: fixed;\n    /* respeta los anchos que defines en cada <th> */\n    border-collapse: collapse;\n  }\n\n  .cardContainerTrafico .table-responsive th,\n  .cardContainerTrafico .table-responsive td {\n    min-width: 0 !important;\n    max-width: none;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .cardContainerTrafico .table-responsive th:nth-child(1),\n  .cardContainerTrafico .table-responsive td:nth-child(1) {\n    width: 16% !important;\n  }\n\n  .cardContainerTrafico .table-responsive th:nth-child(2),\n  .cardContainerTrafico .table-responsive td:nth-child(2) {\n    width: 14% !important;\n  }\n\n  /* fija el header al top del contenedor .table-responsive */\n  .cardContainerTrafico .table-responsive thead th {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    /* por encima de las filas */\n    background-color: #006699;\n    /* mismo fondo que tu .FondoHeaderTabla2 */\n    color: #fff;\n  }\n\n\n  .containerReporteContratoSeguimiento>table {\n    width: 100%;\n    /* Asegura que la tabla ocupe todo el ancho del contenedor */\n    table-layout: fixed;\n    /* Hace que las celdas tengan un tamaño fijo, evitando que se estiren */\n  }\n}\n\n/* Tráfico ocupa el viewport y deja el desplazamiento vertical a la grilla. */\n@media (min-width: 768px) {\n  html.table-page-lock,\n  body:has(.trafico-page),\n  body:has(.solicitudes-page) {\n    overflow-y: hidden;\n  }\n\n  body:has(.trafico-page) #root,\n  body:has(.trafico-page) .wrapper,\n  .trafico-page {\n    height: 100dvh;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .trafico-page .layout-container,\n  .trafico-page .layout-page,\n  .trafico-page .content-wrapper {\n    min-height: 0;\n  }\n\n  .trafico-page .layout-page {\n    height: 100%;\n  }\n\n  .trafico-page .content-wrapper {\n    height: auto;\n    flex: 1 1 auto;\n  }\n\n  .trafico-page .content-wrapper {\n    overflow: hidden;\n  }\n\n  .trafico-page .container-fluid.container-p-y {\n    min-width: 0;\n    min-height: 0;\n    height: 100%;\n    overflow: hidden;\n  }\n\n  .trafico-page .trafico-table-freeze-wrapper {\n    overflow-x: hidden !important;\n  }\n\n  .trafico-page .trafico-table-freeze-2 {\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n  }\n\n  .trafico-page .trafico-live-stack {\n    height: calc(100dvh - 186px);\n    min-height: 0;\n  }\n\n}\n\n/* Repsonsive */\n@media (max-width: 768px) {\n\n  .filterTraficCss {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .FilterSearchTraficc {\n    margin-bottom: 24px;\n  }\n\n  .countersColorsTrafico {\n    justify-content: center;\n    /* Por ejemplo, alineados a la izquierda */\n    gap: 32px 20px;\n    margin-bottom: 24px;\n    margin-top: 12px;\n    /* Distinto gap horizontal y vertical */\n  }\n\n  .containerCardsTrafico {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n  }\n\n  .containerCardsTrafico .ContainerContratoInitial {\n    padding: 15px;\n  }\n\n  .containerCardsTrafico .ContainerContratoInitial .infoEmpresaContrato span {\n    font-weight: 700;\n  }\n\n  .opcionesContrato {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .moreInfoStyles {\n    background-color: #e6eef7;\n    padding: 12px;\n    border-radius: 12px;\n    margin-top: 24px;\n  }\n\n  .moreInfoStyles span {\n    font-weight: 700;\n  }\n\n  .controlHistoricoH4 {\n    margin-top: 50px;\n  }\n\n  .containerReporteContratoSeguimiento {\n    width: 100%;\n    overflow-x: scroll;\n  }\n\n  .tableReporteContratoSeguimiento .sticky-header {\n    width: 100px;\n  }\n\n.containerReporteContratoSeguimientoHistorico {\n    width: 100%;\n    overflow-x: scroll;\n  }\n\n  .tableReporteContratoSeguimientoHistorico .sticky-header {\n    width: 100px;\n  }\n\n  .controlDeviceTitle {\n    margin-top: 50px;\n  }\n\n  .cardControlDevice {\n    width: 100%;\n    overflow-x: scroll;\n  }\n\n  .usuarios .table-responsive {\n    width: 100% !important;\n    border-radius: 12px;\n  }\n\n  .usuarios .table-responsive .table {\n    width: 1290px !important;\n    overflow-x: auto;\n  }\n\n  .usuarios .buttonUsuarios button {\n    width: 100% !important;\n    margin-top: 12px;\n  }\n\n  .rolesTable {\n    width: 100% !important;\n\n  }\n\n  /* mantiene scroll horizontal si el ancho total supera el viewport */\n  .rolesTable .table {\n    min-width: 490px;\n    overflow-x: scroll;\n  }\n\n  /* evita colapso extremo */\n  .rolesTable .table thead th:nth-child(1),\n  .rolesTable .table tbody td:nth-child(1) {\n    width: 80px;\n  }\n\n  /* ID más compacto */\n  .rolesTable .table thead th:nth-child(3),\n  .rolesTable .table tbody td:nth-child(3) {\n    width: 90px;\n  }\n\n  .buttonsRole {\n    display: flex;\n    flex-direction: column !important;\n    gap: 12px;\n  }\n\n  .buttonsRole button {\n    width: 100% !important;\n    box-sizing: border-box;\n    text-align: center;\n    font-size: 12px;\n  }\n\n\n\n  /* OPCIONES más compacta */\n\n\n}\n\n.en-vivo-panel {\n  min-height: 420px;\n  padding: 14px;\n  background:\n    radial-gradient(1200px 280px at 8% -20%, rgba(28, 145, 255, 0.12), transparent 60%),\n    linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);\n  max-width: 100%;\n  box-sizing: border-box;\n  border-radius: 14px;\n  border: 1px solid #d5e3f2;\n}\n\n.en-vivo-layout {\n  display: grid;\n  grid-template-columns: minmax(320px, 1.6fr) minmax(280px, 1fr);\n  gap: 16px;\n  align-items: start;\n  width: 100%;\n}\n\n.en-vivo-left,\n.en-vivo-right {\n  min-height: 420px;\n  width: 100%;\n  min-width: 0;\n}\n\n.en-vivo-card {\n  background: linear-gradient(140deg, #1b2432 0%, #2d2d2d 100%);\n  color: #f8fbff;\n  border: 1px solid rgba(90, 177, 255, 0.25);\n  border-radius: 14px;\n  padding: 16px;\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.32);\n  width: 100%;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.en-vivo-title {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.en-vivo-title-text {\n  line-height: 1;\n}\n\n.en-vivo-title .en-vivo-live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e11d48;\n  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);\n  animation: en-vivo-pulse 1.2s ease-out infinite;\n}\n\n.en-vivo-text {\n  font-size: 12px;\n  margin-bottom: 10px;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.en-vivo-contrato {\n  font-size: 12px;\n  margin-bottom: 12px;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.en-vivo-preview {\n  position: relative;\n  background: #050b14;\n  border-radius: 12px;\n  overflow: hidden;\n  aspect-ratio: 16 / 9;\n  margin-bottom: 12px;\n  border: 1px solid rgba(111, 193, 255, 0.2);\n  max-width: 100%;\n}\n\n.en-vivo-preview video,\n.en-vivo-iframe,\n.en-vivo-media {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.en-vivo-media {\n  object-fit: contain;\n}\n\n.en-vivo-iframe {\n  border: 0;\n}\n\n.en-vivo-overlay-actions {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  display: flex;\n  gap: 8px;\n}\n\n.en-vivo-fullscreen-btn,\n.en-vivo-pip-btn {\n  background: rgba(15, 23, 42, 0.8);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.en-vivo-preview.is-fullscreen {\n  aspect-ratio: auto;\n  border-radius: 0;\n  margin-bottom: 0;\n}\n\n.en-vivo-preview.is-fullscreen video {\n  object-fit: contain;\n}\n\n.en-vivo-placeholder {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  background: rgba(0, 0, 0, 0.4);\n  text-align: center;\n  padding: 8px;\n}\n\n.en-vivo-loader {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.9);\n  background: rgba(0, 0, 0, 0.5);\n  text-align: center;\n  padding: 8px;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.en-vivo-spinner {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #fff;\n  animation: en-vivo-spin 0.9s linear infinite;\n}\n\n@keyframes en-vivo-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.en-vivo-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.en-vivo-stream-control {\n  display: inline-flex;\n  align-items: stretch;\n  border-radius: 10px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);\n  border: 1px solid #3aa2de;\n  min-height: 36px;\n  box-shadow: 0 8px 20px rgba(27, 132, 197, 0.25);\n}\n\n.en-vivo-stream-btn {\n  border: 0;\n  background: transparent;\n  color: #fff;\n  padding: 0 16px;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.en-vivo-stream-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.en-vivo-stream-btn:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.8);\n  outline-offset: -2px;\n}\n\n.en-vivo-duration-select {\n  border: 0;\n  border-left: 1px solid rgba(255, 255, 255, 0.35);\n  background: transparent;\n  color: #fff;\n  padding: 0 32px 0 12px;\n  min-width: 74px;\n  cursor: pointer;\n  appearance: none;\n  background-image: linear-gradient(45deg, transparent 50%, #fff 50%), linear-gradient(135deg, #fff 50%, transparent 50%);\n  background-position: calc(100% - 15px) 13px, calc(100% - 10px) 13px;\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n}\n\n.en-vivo-duration-select:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.8);\n  outline-offset: -2px;\n}\n\n.en-vivo-duration-select option {\n  color: #0f172a;\n}\n\n.en-vivo-error {\n  font-size: 11px;\n  color: #ffb3b3;\n  margin-bottom: 8px;\n}\n\n.en-vivo-stream-carousel-wrap {\n  margin-bottom: 10px;\n}\n\n.en-vivo-stream-carousel-title {\n  font-size: 12px;\n  color: #d1d5db;\n  margin-bottom: 6px;\n}\n\n.en-vivo-stream-carousel {\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  scrollbar-width: thin;\n}\n\n.en-vivo-stream-thumb {\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(17, 24, 39, 0.7);\n  border-radius: 8px;\n  padding: 6px;\n  min-width: 170px;\n  width: 170px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.en-vivo-stream-thumb:hover {\n  border-color: rgba(59, 130, 246, 0.8);\n}\n\n.en-vivo-stream-thumb.is-active {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.45) inset;\n}\n\n.en-vivo-stream-thumb-frame {\n  width: 100%;\n  height: 92px;\n  border: 0;\n  border-radius: 6px;\n  background: #000;\n  pointer-events: none;\n}\n\n.en-vivo-stream-thumb-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #0b2034 0%, #12395f 100%);\n  color: #e2f2ff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n}\n\n.en-vivo-stream-thumb-label {\n  font-size: 11px;\n  color: #e5e7eb;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.en-vivo-tracking {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 16px;\n  color: #1f2a3a;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);\n  border: 1px solid #d7e5f3;\n  width: 100%;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.modal .en-vivo-panel {\n  max-height: calc(100vh - 220px);\n  overflow: auto;\n}\n\n.modal .en-vivo-layout {\n  align-items: stretch;\n}\n\n.modal .en-vivo-left,\n.modal .en-vivo-right {\n  min-height: 0;\n}\n\n.en-vivo-tracking-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.en-vivo-tracking-toggle {\n  display: none;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #0f172a;\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.en-vivo-tracking-title {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.en-vivo-kpis {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.en-vivo-kpi {\n  background: #0b2234;\n  color: #fff;\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n\n.en-vivo-kpi-label {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-bottom: 4px;\n}\n\n.en-vivo-kpi-value {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.en-vivo-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px 16px;\n  font-size: 12px;\n  margin-bottom: 12px;\n  color: #44596f;\n}\n\n.en-vivo-info-grid span {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.en-vivo-tab-title {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.en-vivo-counter {\n  margin-left: 8px;\n  font-weight: 600;\n  color: #0b5c8f;\n}\n\n.en-vivo-refresh-btn {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.en-vivo-refresh-icon {\n  font-size: 12px;\n}\n\n.en-vivo-refresh-spinner {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid rgba(15, 23, 42, 0.25);\n  border-top-color: #0b5c8f;\n  animation: en-vivo-spin 0.9s linear infinite;\n}\n\n.en-vivo-table {\n  border: 1px solid #d8e6f3;\n  border-radius: 10px;\n  overflow-x: auto;\n  overflow-y: auto;\n  max-height: 360px;\n  width: 100%;\n  background: #fdfefe;\n}\n\n.en-vivo-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.en-vivo-table th,\n.en-vivo-table td {\n  padding: 8px;\n  border-bottom: 1px solid #e2e8f0;\n  text-align: left;\n}\n\n.en-vivo-table th {\n  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);\n  color: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.en-vivo-table tbody tr:hover {\n  background: #eff7ff;\n}\n\n.en-vivo-file-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #bfd4ea;\n  border-radius: 8px;\n  background: #f7fbff;\n  color: #0b5c8f;\n  cursor: pointer;\n}\n\n.en-vivo-file-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.en-vivo-empty {\n  text-align: center;\n  padding: 16px;\n  color: #64748b;\n}\n\n@media (max-width: 992px) {\n  .en-vivo-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .en-vivo-panel {\n    padding: 12px;\n  }\n\n  .en-vivo-card,\n  .en-vivo-tracking {\n    padding: 12px;\n  }\n\n  .en-vivo-kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .en-vivo-kpi {\n    text-align: left;\n  }\n\n  .en-vivo-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .en-vivo-table table {\n    min-width: 520px;\n  }\n}\n\n@media (max-width: 576px) {\n  .en-vivo-panel {\n    padding: 8px;\n  }\n\n  .en-vivo-layout {\n    gap: 12px;\n  }\n\n  .en-vivo-card,\n  .en-vivo-tracking {\n    padding: 10px;\n    border-radius: 10px;\n  }\n\n  .en-vivo-preview {\n    margin-bottom: 10px;\n  }\n\n  .en-vivo-overlay-actions {\n    right: 8px;\n    bottom: 8px;\n    flex-direction: column;\n  }\n\n  .en-vivo-fullscreen-btn,\n  .en-vivo-pip-btn {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .en-vivo-kpi {\n    padding: 8px 10px;\n  }\n\n  .en-vivo-kpi-value {\n    font-size: 12px;\n  }\n\n  .en-vivo-table table {\n    min-width: 480px;\n  }\n\n  .en-vivo-table {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .en-vivo-tracking-toggle {\n    display: inline-flex;\n  }\n\n  .en-vivo-tracking.is-collapsed .en-vivo-kpis,\n  .en-vivo-tracking.is-collapsed .en-vivo-info-grid,\n  .en-vivo-tracking.is-collapsed .en-vivo-tab-title,\n  .en-vivo-tracking.is-collapsed .en-vivo-table {\n    display: none;\n  }\n\n  .en-vivo-tracking.is-collapsed {\n    padding-bottom: 12px;\n  }\n\n  .en-vivo-actions {\n    width: 100%;\n  }\n\n  .en-vivo-stream-control {\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n  }\n\n  .en-vivo-stream-btn {\n    flex: 1 1 auto;\n    min-width: 0;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .en-vivo-duration-select {\n    flex: 0 0 auto;\n    box-sizing: border-box;\n  }\n}\n\n/* Pulso suave con halo usando el color primario de MDB (fallback a azul) */\n@keyframes pulse-shadow {\n  0% {\n    box-shadow: 0 0 0 0 rgba(var(--mdb-primary-rgb, 13, 110, 253), .45);\n  }\n\n  70% {\n    box-shadow: 0 0 0 12px rgba(var(--mdb-primary-rgb, 13, 110, 253), 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(var(--mdb-primary-rgb, 13, 110, 253), 0);\n  }\n}\n\n@keyframes pulse-scale {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.03);\n  }\n}\n\n.btn-pulse {\n  animation: pulse-shadow 1.6s ease-out infinite, pulse-scale 1.6s ease-in-out infinite;\n  will-change: transform, box-shadow;\n}\n\n.live-fab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.live-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #ff2d2d;\n  box-shadow: 0 0 0 0 rgba(255, 45, 45, 0.6);\n  animation: live-dot-pulse 1.4s ease-out infinite;\n}\n\n.live-fab.is-live .live-indicator {\n  background: #fff;\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);\n  animation: live-dot-pulse-white 1.4s ease-out infinite;\n}\n\n@keyframes live-dot-pulse {\n  0% {\n    transform: scale(0.85);\n    box-shadow: 0 0 0 0 rgba(255, 45, 45, 0.7);\n  }\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(255, 45, 45, 0);\n  }\n  100% {\n    transform: scale(0.85);\n    box-shadow: 0 0 0 0 rgba(255, 45, 45, 0);\n  }\n}\n\n@keyframes live-dot-pulse-white {\n  0% {\n    transform: scale(0.85);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);\n  }\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);\n  }\n  100% {\n    transform: scale(0.85);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n  }\n}\n\n/* Respeta accesibilidad: sin animaciones para quien lo pida */\n@media (prefers-reduced-motion: reduce) {\n  .btn-pulse {\n    animation: none;\n  }\n}\n\n\n\n/* Estilos para los dropdowns */\n/* .dropbtn {\n  padding: 10px;\n  font-size: 16px;\n  border: none;\n  cursor: pointer;\n} */\n\n/* Estilos para el contenedor del dropdown */\n/* .dropdown {\n  position: relative;\n  display: inline-block;\n} */\n\n/* Estilos para las opciones del dropdown */\n/* .dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n} */\n\n/* Estilos para las opciones del dropdown al estar activo */\n/* .dropdown-content.active {\n  display: block;\n} */\n\n/* Estilos para las opciones del dropdown */\n/* .dropdown-content span {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n  cursor: pointer;\n} */\n\n/* Estilos para las opciones del dropdown al pasar el cursor sobre ellas */\n/* .dropdown-content span:hover {\n  background-color: #f1f1f1;\n} */\n\n.seguimiento-links-row {\n  margin-bottom: 14px !important;\n}\n\n/* Reserva espacio para que el hover de los botones no quede recortado arriba. */\n.seguimiento-links-row > div {\n  padding: 7px 4px 4px !important;\n}\n\n.seguimiento-links a {\n  color: #2368ff;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.seguimiento-links a:hover {\n  text-decoration: underline;\n}\n\n.seguimiento-links {\n  align-items: center;\n  gap: 8px;\n  width: max-content;\n}\n\n.seguimiento-links .seguimiento-action-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 34px;\n  padding: 6px 11px;\n  border: 1px solid #d7e5f2;\n  border-radius: 10px;\n  background: #f7fbff;\n  color: #195d8d;\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n  transition: background-color .18s ease, border-color .18s ease, transform .18s ease;\n}\n\n.seguimiento-links .seguimiento-action-link:hover {\n  border-color: #8ec3e8;\n  background: #eaf5fd;\n  text-decoration: none;\n  transform: translateY(-1px);\n}\n\n.seguimiento-links .seguimiento-action-link > i {\n  display: inline-block !important;\n  font-size: 18px;\n  line-height: 1;\n}\n\n/* Estos enlaces son acciones, no pestañas: ninguno debe aparecer activo por defecto. */\n.seguimiento-links .seguimiento-action-link:first-child {\n  border-color: #d7e5f2 !important;\n  background: #f7fbff !important;\n  color: #195d8d !important;\n  box-shadow: none !important;\n}\n\n.seguimiento-links .seguimiento-action-link:first-child:hover {\n  border-color: #8ec3e8 !important;\n  background: #eaf5fd !important;\n  color: #195d8d !important;\n}\n\n.seguimiento-topbar {\n  border-radius: 12px;\n  background: linear-gradient(120deg, #0b5c8f 0%, #1b84c5 100%);\n  box-shadow: 0 10px 28px rgba(11, 92, 143, 0.2);\n}\n\n.seguimiento-kpis .seguimiento-kpi-card {\n  font-family: \"IBM Plex Mono\", Consolas, monospace;\n  font-size: 15px;\n  color: #fff;\n  text-align: center;\n  border-radius: 12px;\n  padding: 6px 10px;\n  background: linear-gradient(180deg, #071a28 0%, #02070d 100%);\n  border: 1px solid #11344a;\n  box-shadow: inset 0 0 0 1px rgba(88, 167, 255, 0.14);\n}\n\n.seguimiento-map {\n  border: 1px solid #c9d9e7;\n  border-radius: 14px;\n  min-height: 500px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.seguimiento-panel {\n  border: 1px solid #d6e3ef;\n  border-radius: 14px;\n  padding: 10px;\n  background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);\n}\n\n.seguimiento-switches {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.seguimiento-meta-card {\n  border: 1px solid #d6e3ef;\n  border-radius: 12px;\n  background: #fff;\n  padding: 8px 10px;\n}\n\n.seguimiento-meta-info-button {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  z-index: 2;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #007bff;\n  background: #eef6ff;\n  box-shadow: 0 6px 14px rgba(0, 123, 255, 0.12);\n  cursor: pointer;\n}\n\n.seguimiento-actions-info-button {\n  display: none !important;\n}\n\n.seguimiento-meta-info-button:hover,\n.seguimiento-meta-info-button:focus-visible {\n  background: #dceeff;\n  outline: 2px solid rgba(0, 123, 255, 0.25);\n  outline-offset: 2px;\n}\n\n/* Datos adicionales alineados con las columnas reales de la grilla de Tráfico. */\n.trafico-expanded-details {\n  display: flex;\n  justify-content: space-around;\n  gap: 16px;\n  width: calc(100% + 16px);\n  margin-left: -8px;\n  min-width: 0;\n  align-items: start;\n  box-sizing: border-box;\n}\n\n.trafico-expanded-details > div {\n  flex: 0 1 auto;\n  min-width: 0;\n  padding: 0 8px;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.trafico-expanded-contract {\n  flex-basis: 26%;\n}\n\n.trafico-expanded-container {\n  flex-basis: 26%;\n}\n\n.trafico-expanded-route {\n  flex-basis: 40%;\n}\n\n@media (max-width: 1399px) {\n  .trafico-expanded-details {\n    gap: 10px;\n  }\n\n  .trafico-expanded-details > div {\n    flex-basis: 30%;\n  }\n}\n\n.seguimiento-table-card {\n  border: 1px solid #d6e3ef;\n  border-radius: 12px;\n  background: #f9fcff;\n  padding: 8px;\n}\n\n.seguimiento-table-card .tabs {\n  border-bottom: 1px solid #d6e3ef !important;\n  gap: 8px !important;\n}\n\n.seguimiento-table-card .tab {\n  border-radius: 10px !important;\n  padding: 7px 14px !important;\n  font-weight: 600;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento {\n  border-radius: 10px;\n  overflow: hidden;\n  width: 100%;\n  min-width: 100%;\n  table-layout: fixed;\n}\n\n.seguimiento-table-card .tableReporteContratoSeguimiento tbody tr:hover {\n  cursor: pointer;\n}\n\n.seguimiento-historico-app {\n  background:\n    radial-gradient(1100px 280px at 5% -15%, rgba(28, 163, 236, 0.12), transparent 60%),\n    linear-gradient(180deg, #f7fbff 0%, #eef4fb 100%);\n  border: 1px solid #d7e5f2;\n  border-radius: 14px;\n  padding: 10px 12px;\n}\n\n.seguimiento-historico-app .seguimiento-links-row {\n  margin-bottom: 14px !important;\n}\n\n.seguimiento-historico-app .seguimiento-links {\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n}\n\n.seguimiento-historico-app .seguimiento-topbar {\n  border-radius: 12px;\n  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);\n  box-shadow: 0 10px 24px rgba(11, 92, 143, 0.22);\n  border: 1px solid #2f92cf;\n}\n\n.seguimiento-historico-app .seguimiento-kpi-card {\n  border-radius: 12px;\n  border: 1px solid #153650;\n  background: linear-gradient(180deg, #061725 0%, #02080f 100%) !important;\n  box-shadow: inset 0 0 0 1px rgba(96, 175, 255, 0.12);\n  min-height: 76px;\n}\n\n.seguimiento-historico-app .seguimiento-map {\n  border-radius: 14px;\n  min-height: 500px;\n  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.12);\n  border: 1px solid #cddcea !important;\n}\n\n.seguimiento-historico-app .seguimiento-panel {\n  border: 1px solid #d2e2f1;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 10px 12px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n}\n\n.seguimiento-historico-app .seguimiento-table-card {\n  border: 1px solid #d3e2f1;\n  border-radius: 12px;\n  background: #f9fcff;\n  padding: 8px;\n}\n\n.seguimiento-historico-app .tabs {\n  border-bottom: 1px solid #d3e2f1;\n  gap: 8px;\n}\n\n.seguimiento-historico-app .tab {\n  border-radius: 10px !important;\n  border: 1px solid #c8dbeb;\n  background: #f2f8ff;\n  color: #1d5780;\n}\n\n.seguimiento-historico-app .tab.active {\n  background: linear-gradient(135deg, #0b5c8f, #1b84c5) !important;\n  color: #fff;\n  border-color: transparent;\n  box-shadow: 0 8px 20px rgba(27, 132, 197, 0.24);\n}\n\n.seguimiento-historico-app .tableReporteContratoSeguimiento th {\n  min-height: 46px;\n  padding: 10px 8px !important;\n  font-size: 12px;\n  vertical-align: middle;\n}\n\n.seguimiento-historico-app .tableReporteContratoSeguimiento td {\n  min-height: 42px;\n  padding: 8px 8px !important;\n  vertical-align: middle;\n}\n.base-modal-xxl-header-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.base-modal-xxl-header-content > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
